'use strict';

import {
  getCurrentLang,
  changeLangToCurrent,
  getCurrentLangDirection,
  isDesktopMode,
} from '../../language/langSwitcher';
import { isMobile, settingsData } from '../../../settings';
import { addCloseBtn, addHeader, createHtmlElement, rgbaToHexA } from '../../../functions';
import { closePages, pageResize, setMenuActive } from '../../menu/menu';
import { hideRightNavBar, showRightNavBar, toggleBackBtnInDesktopMode } from '../../navigation/right-nav-bar';
import { addCustomPreloader, removeCustomPreloader } from '../../preloader/preloader';
import {
  closePoiInfoWindowCardInOrbit,
  poiOrbitCardSwitchingLang,
  resetOrbitActiveRoute,
  setActiveRouteInOrbitCard,
} from '../../poi/poiCss';
import { openPage } from '../../menu/menu';
import { renderUpdateValuesOnDemand } from '../../../app';
import { showHideButtonPlay } from '../../camera-auto-tour/cameraTour';
import { transferToBuilding } from '../../threejs/camera'
import Notiflix from 'notiflix';
import { desktopErrorIcon } from '../widgets';
import { autoRotateTimerAction } from '../../controls/orbitControls';

const canvasClass = 'bmby-poi-wrapp';
export let map;
let directionsRenderer;
const mapData = {};
let poiZoom;
let lang;
let dir;
let isPortrait;
const styleApi = {};
let poiSettings, poiData, poiCategories;
let mapmapData, mapMainContainer;
let startPoint;

let swipeMenu;
let swipeMiniCard;
let clickX;
let clickY;

//Dragging listeners
let pointStart;
let pointMove;
let pointUp;
let pointStartTouch;
let pointMoveTouch;
let pointUpTouch;


// Dragging variables
let active = false;
let currentX;
let currentY;
let initialX;
let initialY;
let xOffset = 0;
let yOffset = 0;

// Home direction icons
let topIcon;
let topRightIcon;
let topLeftIcon;
let bottomIcon;
let bottomLeftIcon;
let bottomRightIcon;
let rightIcon;
let leftIcon;

//Check error state
let apiError = false;

const query = `?key=${config.googleAPI}`;

export function poiWidgetInit(crm){
  [poiSettings, poiData, poiCategories] = crm;

  const mainContainer = createHtmlElement(document.body,'','div',['widget__container']);
  mainContainer.dataset.menuItem = 'map';
  mainContainer.style.visibility = 'hidden';
  mainContainer.style.opacity = 0;
  // mainContainer.style.paddingTop = settingsData.widgetsPaddingTop + 'px';

  pageResize(mainContainer);
  // mainContainer.classList.add('show-page');

  // addCustomPreloader(mainContainer,'map');

  mapMainContainer = createHtmlElement(mainContainer,'','div',[`${canvasClass}`,'map__container']);

  parseStyle();

  lang = getCurrentLang();
  dir = getCurrentLangDirection();
  isPortrait = isPortraitMode();

  poiZoom = Number(poiSettings.poiZoom);

  if(!checkPoiResponse(poiData,poiCategories)){
    showErrorPage();
    apiError = true;
    return;
  }

  addPoiToCategory(poiData, poiCategories);

  const scriptInterval = setInterval(async ()=>{
    addScripts();
    if (scriptsChecker()){
      clearInterval(scriptInterval);
      await initMap(poiSettings, poiData, poiCategories);
      // removeCustomPreloader('map');
    }
  },200);

  // window.addEventListener('orientationchange',orientationHandler);
}

function parseStyle () {
  styleApi.colors = {};
  config.style.colors.forEach(color=>{
    styleApi.colors[color.key] = color.value;
  });
}

export function addPoiWidgetBasicStyle () {
  document.head.innerHTML +='<style id="basicStyle">'+basicStyleCss+'</style>';
}


export function addScripts () {
  if (lang === undefined){
    lang = getCurrentLang();
  }
  const markerCluster = isLoadedScript('https://unpkg.com/@google/markerclustererplus@4.0.1/dist/markerclustererplus.min.js');
  if (!markerCluster){
    loadScript('https://unpkg.com/@google/markerclustererplus@4.0.1/dist/markerclustererplus.min.js','marker');
  }
  const mapApi = isLoadedScript('https://maps.googleapis.com/maps/api/js'+query+'&language='+lang);
  if (!mapApi){
    loadScript('https://maps.googleapis.com/maps/api/js'+query+'&language='+lang,'maps')
  }
  const snazzy = isLoadedScript('https://cdn.jsdelivr.net/npm/snazzy-info-window@1.1.1/dist/snazzy-info-window.min.js');
  if (!snazzy){
    loadScript('https://cdn.jsdelivr.net/npm/snazzy-info-window@1.1.1/dist/snazzy-info-window.min.js','snazzy');
  }
}

async function loadScript(path,name) {
  const script = document.createElement('script');
  script.type ='text/javascript';
  script.id = name;
  script.src = path;
  script.async =false;
  document.head.appendChild(script);
}

function removeScript (id) {
  const script = document.head.querySelector(`#${id}`);
  script && script.remove();
}

function isLoadedScript(path) {
  return document.head.querySelectorAll('[src="' + path + '"]').length > 0;
}

export function scriptsChecker () {
  if (window.google === undefined || window.google.maps === undefined ){
    return false;
  }
  return Boolean(window.MarkerClusterer && Object.keys(window.google?.maps).length && window.SnazzyInfoWindow);
}

export function mapElementStyleToggle (page) {
  if (!isMobile || page?.getAttribute('data-menu-item') !== 'map'){
    return;
  }

  if (page.classList.contains('show-page')){
    return;
  }

  const burger = document.querySelector('.burger__mobile__btn');
  const backBtn = page.querySelector('.widget__container-close');

  if (!burger.classList.contains('widget__drop__shadow') && !backBtn?.classList.contains('widget__drop__shadow')){
    burger.classList.add('widget__drop__shadow');
    backBtn?.classList.add('widget__drop__shadow');
  } else {
    burger.classList.remove('widget__drop__shadow');
    backBtn?.classList.remove('widget__drop__shadow');
  }

  // burger && burger.classList.toggle('widget__drop__shadow');
  // backBtn && backBtn.classList.toggle('widget__drop__shadow');
}

export async function initMap (poiSettings, poiData, poiCategories) {
  let mainContainer;
  let defaultMainBuildingIcon;
  const widgetContainerExist = document.querySelector('.widget__container[data-menu-item="map"]');
  if (widgetContainerExist){
    mainContainer = widgetContainerExist;
  } else {
    mainContainer = createHtmlElement(document.body,'','div',['widget__container']);
    mainContainer.dataset.menuItem = 'map';
    mainContainer.style.visibility = 'hidden';
    mainContainer.style.opacity = 0;
    // mainContainer.style.paddingTop = settingsData.widgetsPaddingTop + 'px';
  }

  if (!document.querySelector(`.${canvasClass}.map__container`)){
    mapMainContainer = createHtmlElement(mainContainer,'','div',[`${canvasClass}`,'map__container']);
  }

  if(!checkPoiResponse(poiData,poiCategories)){
    showErrorPage();
    return;
  }

  mapData.snazzyWindow = [];
  mapData.staticMarkersOnMap=[];
  mapData.filteredMarkers = {};
  mapData.filterResault = [];
  mapData.mapSettings = {
    zoom: 22,
  };

  topIcon = generateSvg(await loadIcon('HOME__TOP'),'#1A2F43',styleApi.colors.brand2.split(','),true);
  topLeftIcon = generateSvg(await loadIcon('HOME__TOP__LEFT'),'#1A2F43',styleApi.colors.brand2.split(','),true);
  topRightIcon = generateSvg(await loadIcon('HOME__TOP__RIGHT'),'#1A2F43',styleApi.colors.brand2.split(','),true);
  leftIcon = generateSvg(await loadIcon('HOME__LEFT'),'#1A2F43',styleApi.colors.brand2.split(','),true);
  rightIcon = generateSvg(await loadIcon('HOME__RIGHT'),'#1A2F43',styleApi.colors.brand2.split(','),true);
  bottomIcon = generateSvg(await loadIcon('HOME__BOTTOM'),'#1A2F43',styleApi.colors.brand2.split(','),true);
  bottomLeftIcon = generateSvg(await loadIcon('HOME__BOTTOM__LEFT'),'#1A2F43',styleApi.colors.brand2.split(','),true);
  bottomRightIcon = generateSvg(await loadIcon('HOME__BOTTOM__RIGHT'),'#1A2F43',styleApi.colors.brand2.split(','),true);

  if (isMobile) {
    // addHeader(mainContainer, 'map');
    addCloseBtn(mainContainer);
  }


  // Home Marker data
  mapData.staticMarkers = {
    '0':{
      'title': poiSettings.title,
      'lat': Number(poiSettings.latitude),
      'lng': Number(poiSettings.longitude),
      'markerIcon': poiSettings.icon || generateSvg(await loadIcon('mainBuilding'),'#C0C0C0','#000000'),
      'markerText': '',
    }
  };

  await preparePoiData(mapData.filteredMarkers,poiCategories);

  const  mapStyle =  [
    {
      featureType: "poi",
      stylers: [
        { visibility: "off" }
      ]
    },
    {
      featureType: "road",
      elementType: "labels",
      stylers: [
        { visibility: "on" }
      ]
    },
    {
      "featureType": "all",
      "elementType": "labels.text.fill",
      "stylers": [
        // {
        //   "saturation": 36
        // },
        // {
        //   "color": "#333333"
        // },
        // {
        //   "lightness": 40
        // }
      ]
    },
    {
      "featureType": "all",
      "elementType": "labels.text.stroke",
      "stylers": [
        // {
        //   "visibility": "on"
        // },
        // {
        //   "color": "#ffffff"
        // },
        // {
        //   "lightness": 16
        // }
      ]
    },
    {
      "featureType": "all",
      "elementType": "labels.icon",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "administrative",
      "elementType": "geometry.fill",
      "stylers": [
        // {
        //   "color": "#fefefe"
        // },
        // {
        //   "lightness": 20
        // }
      ]
    },
    {
      "featureType": "administrative",
      "elementType": "geometry.stroke",
      "stylers": [
        // {
        //   "color": "#fefefe"
        // },
        // {
        //   "lightness": 17
        // },
        // {
        //   "weight": 1.2
        // }
      ]
    },
    {
      "featureType": "administrative.neighborhood",
      "elementType": "labels",
      "stylers": [
        {
          "visibility": "simplified"
        }
      ]
    },
    {
      "featureType": "administrative.land_parcel",
      "elementType": "labels",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "landscape",
      "elementType": "geometry",
      "stylers": [
        // {
        //   "color": "#f5f5f5"
        // },
        // {
        //   "lightness": 20
        // }
      ]
    },
    {
      "featureType": "landscape.man_made",
      "elementType": "labels",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "poi",
      "elementType": "geometry",
      "stylers": [
        // {
        //   "color": "#f5f5f5"
        // },
        // {
        //   "lightness": 21
        // }
      ]
    },
    {
      "featureType": "poi.park",
      "elementType": "geometry",
      "stylers": [
        // {
        //   "color": "#dedede"
        // },
        // {
        //   "lightness": 21
        // }
      ]
    },
    {
      "featureType": "poi.park",
      "elementType": "labels.text",
      "stylers": [
        {
          "visibility": "on"
        }
      ]
    },
    {
      "featureType": "road.highway",
      "elementType": "geometry.fill",
      "stylers": [
        // {
        //   "color": "#ffffff"
        // },
        // {
        //   "lightness": 17
        // }
      ]
    },
    {
      "featureType": "road.highway",
      "elementType": "geometry.stroke",
      "stylers": [
        // {
        //   "color": "#ffffff"
        // },
        // {
        //   "lightness": 29
        // },
        {
          "weight": 0.2
        }
      ]
    },
    {
      "featureType": "road.arterial",
      "elementType": "geometry",
      "stylers": [
        // {
        //   "color": "#ffffff"
        // },
        // {
        //   "lightness": 18
        // },
        {
          "visibility": "simplified"
        }
      ]
    },
    {
      "featureType": "road.local",
      "elementType": "geometry",
      "stylers": [
        // {
        //   "color": "#ffffff"
        // },
        // {
        //   "lightness": 16
        // },
        {
          "visibility": "simplified"
        }
      ]
    },
    {
      "featureType": "transit",
      "elementType": "geometry",
      "stylers": [
        // {
        //   "color": "#f2f2f2"
        // },
        // {
        //   "lightness": 19
        // }
      ]
    },
    {
      "featureType": "transit.line",
      "elementType": "geometry",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": "water",
      "elementType": "geometry",
      "stylers": [
        // {
        //   "color": "#e9e9e9"
        // },
        // {
        //   "lightness": 17
        // },
        {
          "visibility": "on"
        }
      ]
    }
  ];

  startPoint = new google.maps.LatLng(mapData.staticMarkers['0'].lat,mapData.staticMarkers['0'].lng);
  mapmapData = {
    zoom: mapData.mapSettings.zoom,
    center: startPoint,
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    mapTypeControl: false,
    streetViewControl: false,
    rotateControl: false,
    styles: mapStyle,
    scrollwheel: true,
    zoomControl: false,
    scaleControl: false,
    fullscreenControl: false,
    gestureHandling : 'greedy',
  };

  map = new google.maps.Map(mapMainContainer, mapmapData);
  settingsData.mapMarkers = mapData;
  settingsData.mapCenter = startPoint;

  directionsRenderer = new google.maps.DirectionsRenderer({
    suppressMarkers: true,
    preserveViewport: true,
    provideRouteAlternatives: true,
  });

  directionsRenderer.setMap(map);

  // setTimeout(()=>{
  //   setMapContainerSize();
  // },100);
  setInitialZoom();
  hideAllDefaultMapLinks();
  addStaticMarkers();
  addPoiMarkers();
  addPoiClusters();
  addMapControls();

  const btnGoHome = document.querySelector('.map__go-home__btn');
  btnGoHome.addEventListener('click', ()=> smoothlyAnimatePanTo(map, startPoint));

  map.addListener('center_changed', ()=>{
    // closeMenu();
    mapCenterChangeHandler(btnGoHome, startPoint);
  });

  map.addListener('click', (e)=>{
    e.stop();
  });

  // pageResize(mainContainer);
  // mainContainer.classList.add('show-page');
}

function setMapContainerSize () {
  const mapContainer = getGoogleMapMainContainer();
  const widgetContainer = mapContainer.closest('.widget__container');
  const dir = getCurrentLangDirection();
  const widgetContainerPadding = parseFloat(widgetContainer.style[`padding-${ (dir === 'rtl') ? 'right' : 'left' }`]);

  switch (dir) {
    case 'ltr':
        mapContainer.style.right ='';
        mapContainer.style.left = widgetContainerPadding + 'px';
        console.log(mapContainer.style.left);
      break;
    case 'rtl':
      mapContainer.style.left = '';
      mapContainer.style.right = widgetContainerPadding + 'px';
      break;
  }
}

function getGoogleMapMainContainer () {
  return map.getDiv().firstElementChild;
}

function addPoiListener (marker) {
  const snazzyInfoWindow = new SnazzyInfoWindow({
    marker: marker,
    wrapperClass: 'snazzy-window',
    closeButtonMarkup: '<button type="button" class="icon-close custom-close close-cards-btn"></button>',
    closeWhenOthersOpen: true,
    closeOnMapClick: false,
    panOnOpen: !isMobile,
    edgeOffset: {
      top: 50,
      right: window.innerWidth / 2 - 200,
      left: window.innerWidth / 2 - 200,
      bottom: 200,
    },
    border: false,
    offset:{
      top: '0px',
      left: '0px',
    },
    callbacks: {
      open: () => openSnazzyInfoWindowHandler(marker, snazzyInfoWindow),
      afterClose: () => resetMapRenderer(),
      afterOpen: () => addCloseListener(snazzyInfoWindow),
      beforeClose: () => clearInfoWindowArray() ,
    }
  });

  settingsData.snazzy = snazzyInfoWindow;
}

function disableContextMenu () {
  document.body.setAttribute('oncontextmenu','return false;');
}

function setInfoWindowPosition (snazzyInfoWindow) {
  let contentHeight = snazzyInfoWindow._html.content.getBoundingClientRect().height;
  console.log(snazzyInfoWindow)
  if (contentHeight < 300){
    contentHeight = 428;
  }
  const contentWidth = snazzyInfoWindow._html.content.getBoundingClientRect().width;
  snazzyInfoWindow._opts.offset.top = '-' + (contentHeight + 55) + 'px';
  console.log(snazzyInfoWindow._opts.offset.top)
  if (dir === 'ltr'){
    snazzyInfoWindow._opts.offset.left = '-' + (contentWidth / 2) + 'px';
  } else {
    snazzyInfoWindow._opts.offset.left = (contentWidth / 2) + 'px';
  }
}

function clearInfoWindowArray () {
  mapData.snazzyWindow.splice(0,1);
  const mobileSnazzyContainer = document.querySelector('.mobile__snazzy-window > .snazzy-window');
  if (mobileSnazzyContainer){
    mobileSnazzyContainer.parentElement.classList.remove('open-mobile-card');
    mobileSnazzyContainer.remove();
  }
  changeMenuBtnPosition();
  updateHomeButton();
  resetDragVariables();
}

function addCloseListener (snazzyInfoWindow) {
  const closeBtn = document.querySelector('.custom-close');
  closeBtn.addEventListener('click',() => snazzyInfoWindow.close());
  const container = document.querySelector('.snazzy-content__container');
  container.oncontextmenu = (e)=> { e.preventDefault() };

  mapData.snazzyWindow.push(snazzyInfoWindow);
}

export function resetMapRenderer () {
  directionsRenderer.setMap(null);
  resetOrbitActiveRoute();
}

export function closePrevInfoWindow () {
  if (mapData.snazzyWindow.length > 0){
    mapData.snazzyWindow[0].close();
    resetDragVariables();
  }
}

function exitFromFullscreenCard () {
  const mainContainer = document.querySelector('.widget__container[data-menu-item="map"]');
  const card = mainContainer.querySelector('.snazzy-content__container.open-mobile-card-fullscreen');
  if (card) {
    card.classList.remove('open-mobile-card-fullscreen');
    const closeBtn = mainContainer.querySelector('.card-fullscreen');
    closeBtn.classList.remove('card-fullscreen');
    const container = mapData.snazzyWindow[0].getWrapper();

    if (isPortraitMode()){
      const titleContainer = container.querySelector('.snazzy-content__title-container').getBoundingClientRect().height;
      const infoContainer = container.querySelector('.snazzy-content__container-info').getBoundingClientRect().height;
      const btnHeight = mainContainer.querySelector('.snazzy-contnet__btns-container').getBoundingClientRect().height;
      const photoHeight = mainContainer.querySelector('.snazzy-content__photo-container').getBoundingClientRect().height;
      card.style.maxHeight = titleContainer + photoHeight + infoContainer + btnHeight + 'px';
      card.style.width = '100%';
      setSwipeMiniCard(marker);
    } else {
      card.style.maxWidth = '358px';
    }

  }

}

export function openSnazzyInfoWindowHandler (marker, snazzyInfoWindow,parameters ={}) {
  closePrevInfoWindow(); // If other InfoWindow is opened.
  // closePoiInfoWindowCardInOrbit(false,false);
  let createdInfoWindowContent;
  const mobileSnazzyContainer = document.querySelector('.mobile__snazzy-window');

  if (isMobile){
    menuBtnHandler(document.querySelector('.mobile__menu-container.open-mobile-menu'));
    createdInfoWindowContent = buildInfoWindowMobileContent(marker,false,parameters);
    snazzyInfoWindow.setContent(createdInfoWindowContent);
    const wrapper = snazzyInfoWindow.getWrapper();
    mobileSnazzyContainer.append(wrapper);
    openMiniCard(mobileSnazzyContainer);
    map.panTo(marker.getPosition());

    setSwipeMiniCard(marker);

  } else {
    createdInfoWindowContent = buildInfoWindowContent(marker,false,parameters);
    snazzyInfoWindow.setContent(createdInfoWindowContent);
    const wrapper = snazzyInfoWindow.getWrapper();

    pointStart = google.maps.event.addDomListener(wrapper, "mousedown", (e) => dragStart(e,wrapper));
    pointMove = google.maps.event.addDomListener(wrapper, "mousemove", (e) => drag(e,wrapper));
    pointUp = google.maps.event.addDomListener(wrapper, "mouseup", (e) => dragEnd(e,wrapper));
    pointStartTouch = google.maps.event.addDomListener(wrapper, "touchstart", (e) => dragStart(e,wrapper));
    pointMoveTouch = google.maps.event.addDomListener(wrapper, "touchmove", (e) => drag(e,wrapper));
    pointUpTouch = google.maps.event.addDomListener(wrapper, "touchend", (e) => dragEnd(e,wrapper));

    setInfoWindowPosition(snazzyInfoWindow);

    loadPlacePhoto(marker);
  }
}

function resetDragVariables () {
  currentX = 0;
  currentY = 0;
  initialX = 0;
  initialY = 0;
  xOffset = 0;
  yOffset = 0;
  active = false;

  pointStart && google.maps.event.removeListener(pointStart);
  pointMove && google.maps.event.removeListener(pointMove);
  pointUp && google.maps.event.removeListener(pointUp);
  pointStartTouch && google.maps.event.removeListener(pointStartTouch);
  pointMoveTouch && google.maps.event.removeListener(pointMoveTouch);
  pointUpTouch && google.maps.event.removeListener(pointUpTouch);
}

export function dragStart(e,wrapper) {
  if (isMobile){
    return;
  }

  map.setOptions({draggable: false});

  if (e.type === 'touchstart'){
    initialX = e.touches[0].clientX - xOffset;
    initialY = e.touches[0].clientY - yOffset;
    clickX = e.touches[0].clientX;
    clickY = e.touches[0].clientY;
    active = true;

    document.ontouchmove = (e)=>drag(e,wrapper);
    wrapper.onclick = (e) => {
      e.preventDefault();
    };

  } else {
    initialX = e.clientX - xOffset;
    initialY = e.clientY - yOffset;
    clickX = e.clientX;
    clickY = e.clientY;
    active = true;

    document.onmousemove = (e)=>drag(e,wrapper);
    wrapper.onclick = (e) => {
      e.preventDefault();
    };

  }

}

export function dragEnd(e,wrapper) {
  if (isMobile){
    return;
  }

  map.setOptions({draggable: true});

  initialX = currentX;
  initialY = currentY;

  active = false;
  document.onmousemove = null;
  document.ontouchmove = null;

  if (e.clientX === clickX && e.clientY === clickY){
    wrapper.onclick = null;
  }

}

export function drag(e,wrapper) {
  if (isMobile){
    return;
  }

  if (active) {
    e.preventDefault();

    if (e.type === "touchmove") {
      currentX = e.touches[0].clientX - initialX;
      currentY = e.touches[0].clientY - initialY;
    } else {
      currentX = e.clientX - initialX;
      currentY = e.clientY - initialY;
    }

    xOffset = currentX;
    yOffset = currentY;

    setTranslate(currentX, currentY, wrapper);
  }
}

function setTranslate(xPos, yPos, el) {
  el.style.transform = "translate3d(" + xPos + "px, " + yPos + "px, 0)";
}

function setSwipeMiniCard (marker) {
  if (!marker){
    if (mapData.snazzyWindow.length){
      marker = mapData.snazzyWindow[0]._marker;
    } else {
      return;
    }
  } else {
    swipeMiniCard = new Swipe('.snazzy-window');
  }

  if (isPortrait){
    swipeMiniCard.stop();
    swipeMiniCard.onDown(()=> closeMobileMarkerCard());
    swipeMiniCard.onUp(()=> openMiniCardFullscreen(marker));
    swipeMiniCard.run();
  } else {
    switch (dir) {
      case 'rtl':
        swipeMiniCard.stop();
        swipeMiniCard.onLeft(()=> closeMobileMarkerCard());
        swipeMiniCard.onRight(()=> openMiniCardFullscreen(marker));
        swipeMiniCard.run();
        break;
      case 'ltr':
        swipeMiniCard.stop();
        swipeMiniCard.onLeft(()=> openMiniCardFullscreen(marker));
        swipeMiniCard.onRight(()=> closeMobileMarkerCard());
        swipeMiniCard.run();
        break;
    }
  }

}

function loadPlacePhoto (marker) {
  if (!marker?.data?.sendPhotoRequest && marker?.data?.googleMapsID){
    const placePhoto = getPlacePhoto(marker);
    placePhoto.then((url) => {
      marker.data.infoWindowImg = url;
      const img = document.querySelector('.snazzy-content__img');
      img.src = url;
    });
  }
}

export function openMiniCardFullscreen (marker,orbit = false) {
  let snazzyContent, snazzyWindow;
  if (orbit){
    snazzyContent = document.querySelector('.poi__info-window').querySelector('.snazzy-content__container');
  } else {
    snazzyContent = document.querySelector('.widget__container[data-menu-item="map"]').querySelector('.snazzy-content__container');
    snazzyWindow = document.querySelector('.snazzy-window');
  }

  // const snazzyContent = document.querySelector('.snazzy-content__container');

  snazzyWindow && snazzyWindow.classList.add('card-fullscreen');
  snazzyContent && snazzyContent.classList.add('open-mobile-card-fullscreen');
  setMobileFullscreenCardSize(orbit);

  if (!orbit){
    swipeMiniCard.onDown = ()=>{};
    loadPlacePhoto(marker);
  }
}

export function setMobileFullscreenCardSize (orbit) {
  let snazzyContent;
  if (orbit){
    snazzyContent = document.querySelector('.poi__info-window').querySelector('.snazzy-content__container.open-mobile-card-fullscreen');
  } else {
    snazzyContent = document.querySelector('.widget__container[data-menu-item="map"]').querySelector('.snazzy-content__container.open-mobile-card-fullscreen');
  }

  let value = settingsData.isLandscape ? 0 : 13;
  // let top = orbit ? value : settingsData.widgetsPaddingTop;
  let top = orbit ? value : 0;

  if (!settingsData.isLandscape){
    if (snazzyContent) {
      snazzyContent.style.maxHeight = window.innerHeight - top - 40 + 'px';
      snazzyContent.style.height = window.innerHeight - top + 'px';
      snazzyContent.style.width = 'unset';
    }
  } else {
    if (snazzyContent){
      snazzyContent.style.maxWidth = window.innerWidth + 1 + 'px';
      snazzyContent.style.height = window.innerHeight - top + 'px';
      snazzyContent.style.width = window.innerWidth + 1 + 'px';
    }
  }
}

function closeMenu () {
  if (!isMobile){
    return;
  }
  const menu = document.querySelector('.mobile__menu-container.open-mobile-menu');
  const desktopMenu = document.querySelector('.aside-menu__container.open-aside-menu');
  if (menu){
    menu.classList.remove('open-mobile-menu');
  }
  if (desktopMenu){
    desktopMenu.classList.remove('open-aside-menu');
  }
}

function closeMobileMarkerCard () {
  const closeCardPromise = closeCardSmoothly('.si-content > .snazzy-content__container.open-mobile-card-fullscreen','open-mobile-card-fullscreen');
  const closeMiniCardPromise = closeCardSmoothly('.mobile__snazzy-window.open-mobile-card','open-mobile-card');

  const whenAllAnimated = Promise.all([closeCardPromise,closeMiniCardPromise]);
  whenAllAnimated.then(()=> closePrevInfoWindow());
}

function closeCardSmoothly (containerWithClass, classRemove ) {
  return new Promise(resolve =>{
    const openedMiniCard = document.querySelector(containerWithClass);
    if (!openedMiniCard){
      resolve();
    }
    openedMiniCard.classList.remove(classRemove);
    changeMenuBtnPosition();
    updateHomeButton();
    setTimeout(()=>{
      resolve();
    },500);
  });
}

export async function getPlacePhoto (marker,photoOpt) {
  const request = {
    placeId: (marker.data) ? marker.data.googleMapsID : marker.googleMapsID,
    fields: ['photos']
  };

  if (!request.placeId){
    return '/img/icons/poi/POI__PLUG.jpg';
  }

  const service = new google.maps.places.PlacesService(map);

  return new Promise(  (resolve) => {
     service.getDetails(request,  (result,status) =>{
      if (status === google.maps.places.PlacesServiceStatus.OK){
        if (marker.data){
          marker.data.sendPhotoRequest = true;
        }
        const photos =  result.photos;
        if (photos) {
          if (photoOpt){
              resolve(result.photos[0].getUrl({
              maxHeight: photoOpt.maxHeight,
              maxWidth: photoOpt.maxWidth
            }));
          } else {
              resolve(result.photos[0].getUrl());
          }
        } else if (marker.data) {
          resolve('/img/icons/poi/POI__PLUG.jpg');
        } else {
          resolve('');
        }
      } else {
        showMsg('Can not get the photo.');
        resolve('/img/icons/poi/POI__PLUG.jpg');
      }
    });
  });
}

function getRoute (marker,travelMode) {
  const request = {
    origin: new google.maps.LatLng(mapData.staticMarkers['0'].lat,mapData.staticMarkers['0'].lng),
    destination: marker.getPosition(),
    travelMode
  };

  const service = new google.maps.DirectionsService();

  return new Promise((resolve) => {
    service.route(request, (result,status) =>{
      if (status === 'OK'){
        marker.data.routeResponce[travelMode] = result;
        resolve(result);
      } else {
        showMsg('Can not get the route');
      }
    });
  });
}

export function buildInfoWindowMobileContent (marker,orbit = false,parameters = {}) {
  const routeData = convertMarkerDistanceAndTime(marker);

  const mainContainer = createHtmlElement('','','div',['snazzy-content__container']);
  if (orbit){
    const closeBtn = createHtmlElement(mainContainer,'','div',['poi__info-window__close']);
    closeBtn.addEventListener('click',()=>closePoiInfoWindowCardInOrbit(false));
  }
  // const infoBlock = createHtmlElement(mainContainer,'','div',['snazzy-content__info-block']);

  const titleContainer = createHtmlElement(mainContainer,'','div',['snazzy-content__title-container']);

  const mainContent = createHtmlElement(mainContainer,'','div',['snazzy-content__container-info']);

  const photoContainer = createHtmlElement(mainContainer,'','div',['snazzy-content__photo-container']);
  const img = createHtmlElement(photoContainer,'','img',['snazzy-content__img']);
  img.src = marker.data.infoWindowImg;
  !orbit && loadPlacePhoto(marker);
  const wrapper = createHtmlElement(mainContent,'','div',['snazzy-content__info-wrapper']);

  const title = createHtmlElement(titleContainer,marker.title,'h3',['snazzy-content__title']);

  const categoryContainer = createHtmlElement(titleContainer,'','div',['snazzy-content__category-container']);
  const categoryImageContainer = createHtmlElement(categoryContainer,'','div',['snazzy-content__category-img__container']);
  const categoryImg = createHtmlElement(categoryImageContainer,'','img',['snazzy-content__category-img']);
  // categoryImg.src = generateSvg(marker.data.categoryIconMenuName,'white','white',false);
  categoryImg.src = marker.category_ic;
  const categoryTitle = createHtmlElement(categoryContainer,marker.category,'span',['snazzy-content__category-title']);


  const description = createHtmlElement(wrapper,marker.data.markerDescription,'p',['snazzy-content__description']);

  const routeWrapper = createHtmlElement(wrapper,'','div',['snazzy-content__route-container']);
  routeWrapper.addEventListener('click', (e)=> routesHandler(marker,e.target,orbit));
  //WALK
  const walkRouteContainer = createHtmlElement(routeWrapper,'','div',['snazzy-content__walk-route-container','route', 'icon-walkin']);

  if (!orbit && !parameters.hasOwnProperty('activeRoute')){
    routeWrapper.dataset.selectedRoute = 'WALKING';
    walkRouteContainer.classList.add('active-route');
  }

  walkRouteContainer.dataset.routeType = 'WALKING';
  const timeWalk = createHtmlElement(walkRouteContainer,routeData.timeToPoint.WALKING +' '+ changeLangToCurrent('mins'),'span',['snazzy-content__time-route']);
  timeWalk.dataset.routeType = 'WALKING';
  //BIKE
  const bikeRouteContainer = createHtmlElement(routeWrapper,'','div',['snazzy-content__bike-route-container','route','icon-bike']);
  bikeRouteContainer.dataset.routeType = 'BICYCLING';
  const timeBike = createHtmlElement(bikeRouteContainer,routeData.timeToPoint.BICYCLING +' '+ changeLangToCurrent('mins'),'span',['snazzy-content__time-route']);
  timeBike.dataset.routeType = 'BICYCLING';
  // CAR
  const carRouteContainer = createHtmlElement(routeWrapper,'','div',['snazzy-content__car-route-container','route','icon-car1']);
  carRouteContainer.dataset.routeType = 'DRIVING';
  const timeCar = createHtmlElement(carRouteContainer,routeData.timeToPoint.DRIVING +' '+ changeLangToCurrent('mins'),'span',['snazzy-content__time-route']);
  timeCar.dataset.routeType = 'DRIVING';

  if (parameters.hasOwnProperty('activeRoute')){
    routeWrapper.dataset.selectedRoute = parameters['activeRoute'];
    switch (routeWrapper.dataset.selectedRoute) {
      case 'WALKING':
        walkRouteContainer.classList.add('active-route');
        break;
      case 'BICYCLING':
        bikeRouteContainer.classList.add('active-route');
        break;
      case 'DRIVING':
        carRouteContainer.classList.add('active-route');
        break;
    }
  }

  const socialContainer = createHtmlElement(wrapper,'','div',['snazzy-content__social-container']);
  const address = createHtmlElement(socialContainer,marker.data.address,'span',['snazzy-content__address']);
  if (marker.data.webSiteUrl){
    // const miniUrl = minimizeUrl(marker.data.webSiteUrl);
    const webUrl = createHtmlElement(socialContainer,changeLangToCurrent('Website'),'a',['snazzy-content__website-link']);
    webUrl.href = marker.data.webSiteUrl;
    webUrl.target = '_blank';
  }
  if (marker.data.phone){
    const phone = createHtmlElement(socialContainer,marker.data.phone,'a',['snazzy-content__phone']);
    if (lang === 'he'){
      phone.classList.add('phone__normalize');
    }
    phone.href = 'tel:'+ marker.data.phone;
  }
  // if (marker.data.internationalPhone){
  //   const internationalPhone = createHtmlElement(socialContainer,marker.data.internationalPhone,'a',['snazzy-content__international-phone']);
  //   if (lang === 'he'){
  //     internationalPhone.classList.add('phone__normalize');
  //   }
  //   internationalPhone.href = 'tel:'+ marker.data.internationalPhone;
  // }
  if (marker.data.customPhone){
    const customPhone = createHtmlElement(socialContainer,marker.data.customPhone,'a',['snazzy-content__custom-phone']);
    if (lang === 'he'){
      customPhone.classList.add('phone__normalize');
    }
    customPhone.href = 'tel:'+ marker.data.customPhone;
  }

  const btnsContainer = createHtmlElement(mainContainer,'','div',['snazzy-contnet__btns-container']);
  // const navigateBtn = createHtmlElement(btnsContainer,changeLangToCurrent('Navigate'),'button',['snazzy-content__navigate-btn','button']);
  // navigateBtn.addEventListener('click', () => navigateBtnHandler(marker, routeIconsContainer.dataset.selectedRoute));
  !orbit && navigateBtnHandler(marker, routeWrapper.dataset.selectedRoute);

  const streetViewBtn = createHtmlElement(btnsContainer,changeLangToCurrent('Street view'),'button',['snazzy-content__street-view','button']);
  streetViewBtn.addEventListener('click', () => streetViewHandler(marker,orbit));

  if (parameters.hasOwnProperty('addBackBtn')){
    const backBtn = createHtmlElement(btnsContainer,changeLangToCurrent('Back'),'button',['snazzy-content__back-btn','button','icon-right']);
    backBtn.addEventListener('click', ()=>{
      closePages();
      setMenuActive('3dModel');
      closePrevInfoWindow();
      resetMapRenderer();
      smoothlyAnimatePanTo(map, settingsData.mapCenter);
    });
  }


  return mainContainer;
}

export function buildInfoWindowContent (marker,orbit = false,parameters = {}) {
  const routeData = convertMarkerDistanceAndTime(marker);

  const mainContainer = createHtmlElement('','','div',['snazzy-content__container']);

  if (orbit){
    const closeBtn = createHtmlElement(mainContainer,'','div',['poi__info-window__close']);
    closeBtn.addEventListener('click',()=>closePoiInfoWindowCardInOrbit(true));
  }

  const photoContainer = createHtmlElement(mainContainer,'','div',['snazzy-content__photo-container']);
  const img = createHtmlElement(photoContainer,'','img',['snazzy-content__img']);
  img.src = marker.data.infoWindowImg;
  const infoWrapper = createHtmlElement(mainContainer,'','div',['snazzy-content__info-wrapper']);
  const title = createHtmlElement(infoWrapper,marker.title,'h3',['snazzy-content__title']);
  const categoryContainer = createHtmlElement(infoWrapper,'','div',['snazzy-content__category-container']);
  const categoryImageContainer = createHtmlElement(categoryContainer,'','div',['snazzy-content__category-img__container']);
  const categoryImg = createHtmlElement(categoryImageContainer,'','img',['snazzy-content__category-img']);
  // categoryImg.src = generateSvg(marker.data.categoryIconMenuName,'white','white',false);
  categoryImg.src = marker.category_ic;
  const categoryTitle = createHtmlElement(categoryContainer,marker.category,'span',['snazzy-content__category-title']);
  // categoryTitle.style.color = marker.color;
  const description = createHtmlElement(infoWrapper,marker.data.markerDescription,'p',['snazzy-content__description']);

  const routeWrapper = createHtmlElement(infoWrapper,'','div',['snazzy-content__route-container']);
  //WALK
  const walkRouteContainer = createHtmlElement(routeWrapper,'','div',['snazzy-content__walk-route-container','route', 'icon-walkin']);

  if (!orbit && !parameters.hasOwnProperty('activeRoute')){
    routeWrapper.dataset.selectedRoute = 'WALKING';
    walkRouteContainer.classList.add('active-route');
  }

  routeWrapper.addEventListener('click', (e)=> {
    routesHandler(marker, e.target, orbit);
  });

  walkRouteContainer.dataset.routeType = 'WALKING';
  const timeWalk = createHtmlElement(walkRouteContainer,routeData.timeToPoint.WALKING +' '+ changeLangToCurrent('mins'),'span',['snazzy-content__time-route']);
  timeWalk.dataset.routeType = 'WALKING';
  //BIKE
  const bikeRouteContainer = createHtmlElement(routeWrapper,'','div',['snazzy-content__bike-route-container','route','icon-bike']);
  bikeRouteContainer.dataset.routeType = 'BICYCLING';
  const timeBike = createHtmlElement(bikeRouteContainer,routeData.timeToPoint.BICYCLING +' '+ changeLangToCurrent('mins'),'span',['snazzy-content__time-route']);
  timeBike.dataset.routeType = 'BICYCLING';
  // CAR
  const carRouteContainer = createHtmlElement(routeWrapper,'','div',['snazzy-content__car-route-container','route','icon-car1']);
  carRouteContainer.dataset.routeType = 'DRIVING';
  const timeCar = createHtmlElement(carRouteContainer,routeData.timeToPoint.DRIVING +' '+ changeLangToCurrent('mins'),'span',['snazzy-content__time-route']);
  timeCar.dataset.routeType = 'DRIVING';

  if (parameters.hasOwnProperty('activeRoute')){
    routeWrapper.dataset.selectedRoute = parameters['activeRoute'];
    switch (routeWrapper.dataset.selectedRoute) {
      case 'WALKING':
          walkRouteContainer.classList.add('active-route');
        break;
      case 'BICYCLING':
          bikeRouteContainer.classList.add('active-route');
        break;
      case 'DRIVING':
          carRouteContainer.classList.add('active-route');
        break;
    }
  }

  const socialContainer = createHtmlElement(infoWrapper,'','div',['snazzy-content__social-container']);
  const address = createHtmlElement(socialContainer,marker.data.address,'span',['snazzy-content__address']);

  if (marker.data.webSiteUrl){
    const miniUrl = minimizeUrl(marker.data.webSiteUrl);
    const webUrl = createHtmlElement(socialContainer,miniUrl,'a',['snazzy-content__website-link']);
    webUrl.href = marker.data.webSiteUrl;
    webUrl.target = '_blank';
  }
  if (marker.data.phone){
    const phone = createHtmlElement(socialContainer,marker.data.phone,'a',['snazzy-content__phone']);
    if (lang === 'he'){
      phone.classList.add('phone__normalize');
    }
    phone.href = 'tel:'+ marker.data.phone;
  }
  // if (marker.data.internationalPhone){
  //   const internationalPhone = createHtmlElement(socialContainer,marker.data.internationalPhone,'a',['snazzy-content__international-phone']);
  //   if (lang === 'he'){
  //     internationalPhone.classList.add('phone__normalize');
  //   }
  //   internationalPhone.href = 'tel:'+ marker.data.internationalPhone;
  // }
  if (marker.data.customPhone){
    const customPhone = createHtmlElement(socialContainer,marker.data.customPhone,'a',['snazzy-content__custom-phone']);
    if (lang === 'he'){
      customPhone.classList.add('phone__normalize');
    }
    customPhone.href = 'tel:'+ marker.data.customPhone;
  }

  const btnsContainer = createHtmlElement(mainContainer,'','div',['snazzy-contnet__btns-container']);
  // const navigateBtn = createHtmlElement(btnsContainer,changeLangToCurrent('Navigate'),'button',['snazzy-content__navigate-btn','button']);
  // navigateBtn.addEventListener('click', () => navigateBtnHandler(marker, routeIconsContainer.dataset.selectedRoute));
  !orbit && navigateBtnHandler(marker, routeWrapper.dataset.selectedRoute);

  const streetViewBtn = createHtmlElement(btnsContainer,changeLangToCurrent('Street view'),'button',['snazzy-content__street-view', 'button']);
  streetViewBtn.addEventListener('click', () => {
    streetViewHandler(marker, orbit);
  });

  if (parameters.hasOwnProperty('addBackBtn')){
    const backBtn = createHtmlElement(btnsContainer,changeLangToCurrent('Back'),'button',['snazzy-content__back-btn','button','icon-right']);
    backBtn.addEventListener('click', ()=>{
      closePages();
      setMenuActive('3dModel');
      showHideButtonPlay('show');
      toggleBackBtnInDesktopMode('hide');
      closePrevInfoWindow();
      resetMapRenderer();
      smoothlyAnimatePanTo(map, settingsData.mapCenter);
    });
  }


  return mainContainer;
}

function streetViewHandler (marker,orbit) {
  let panorama;
  if (orbit){
    panorama = getStreetPanorama(marker,undefined,orbit);
  } else {
    panorama = getStreetPanorama(marker,'panorama',orbit);
  }
}

function minimizeUrl (url) {
  const [protocol,,link] = url.split('/');
  return protocol+'//'+link;
}

function routesHandler (marker,selectedRoute,orbit) {
  if (selectedRoute.dataset.routeType){
    let route;
    if (selectedRoute.classList.contains('route')){
      route = selectedRoute;
    } else {
      route = selectedRoute.parentElement;
    }
    route.dataset.selectedRoute = selectedRoute.dataset.routeType;

    resetOrbitActiveRoute();
    resetMapActiveRoute();
    route.classList.add('active-route');

    setActiveRouteInOrbitCard(route.dataset.selectedRoute);

    navigateBtnHandler(marker, route.dataset.selectedRoute);
    if (orbit){
      if (settingsData.mapMarkers.snazzyWindow.length){
        closePrevInfoWindow();
      }
      setMenuActive('map');
      openPage('map');

      settingsData.snazzy._marker = marker;
      settingsData.snazzy._opts.marker = marker;
      settingsData.snazzy._callbacks.open = () => openSnazzyInfoWindowHandler(marker,settingsData.snazzy,{
        activeRoute: route.dataset.selectedRoute,
        addBackBtn: true,
      });

      isMobile && map.panTo(marker.getPosition());
      settingsData.snazzy.open();

    } else if (isMobile && !orbit) {
      const whichCard = whichCardIsOpen();
      if (whichCard === 'fullscreen'){
        exitFromFullscreenCard();
      }
    }
  }
}

function resetMapActiveRoute () {
  const mapContainer = document.querySelector(`.widget__container[data-menu-item="map"]`);
  if (mapContainer){
    const activeRoute = mapContainer.querySelector('.route.active-route');
    activeRoute && activeRoute.classList.remove('active-route');
  }
}

function whichCardIsOpen () {
  const mainContainer = document.querySelector('.widget__container[data-menu-item="map"]');
  const isCardFullscreen = mainContainer.querySelector('.snazzy-content__container.open-mobile-card-fullscreen');
  const isMiniCardOpen = mainContainer.querySelector('.mobile__snazzy-window.open-mobile-card');

  if (isCardFullscreen){
    return 'fullscreen' ;
  }

  if (isMiniCardOpen){
    return 'mini';
  }

  return false;
}

function setNewRoute (selectedRoute, routeDistance, routeTime) {
  const routeTimeElement = document.querySelector('.snazzy-content__time-route');
  const routeDistanceElement = document.querySelector('.snazzy-content__distance-route');
  routeTimeElement.textContent = routeTime + ' ' + changeLangToCurrent('mins');
  routeDistanceElement.textContent = routeDistance + ' '+changeLangToCurrent('km');
  selectedRoute.classList.add('active-route');
}

function navigateBtnHandler (marker, travelMode) {
  // const btn = document.querySelector('.snazzy-content__navigate-btn');
  // if (btn.classList.contains('navigate__active')){
  //   changeNavigateBtn();
  //   resetMapRenderer();
  //   return;
  // }
  directionsRenderer.setMap(map);

  const isRouteExist = marker.data.routeResponce[travelMode];
  if (!isRouteExist){
    const route = getRoute(marker,travelMode);
    route.then((dataRoute) =>{
      directionsRenderer.setDirections(dataRoute);
      changeNavigateBtn();
      // isMobile && exitFromFullscreenCard(marker);
    });
  } else {
    directionsRenderer.setDirections(isRouteExist);
    changeNavigateBtn();
    // isMobile && exitFromFullscreenCard(marker);
  }
}

function changeNavigateBtn () {
  const btn = document.querySelector('.snazzy-content__navigate-btn');
  if (btn) {
    btn.classList.toggle('navigate__active');
  }
}

function convertMarkerDistanceAndTime (marker) {
  return {
    distanceToPoint: {
      'BICYCLING': Number((marker.data.distanceToPoint.bike / 1000).toFixed(1)),
      'DRIVING': Number((marker.data.distanceToPoint.drive / 1000).toFixed(1)),
      'WALKING': Number((marker.data.distanceToPoint.walk / 1000).toFixed(1)),
    },
    timeToPoint: {
      'BICYCLING': Math.round(Number(marker.data.timeToPoint.bike) / 60),
      'DRIVING': Math.round(Number(marker.data.timeToPoint.drive) / 60),
      'WALKING': Math.round(Number(marker.data.timeToPoint.walk) / 60)
    }
  }
}

function addPoiClusters () {
  let allMarkersForCluster = [];

  Object.values(mapData.allPoiMarkers).forEach(markers =>{
    allMarkersForCluster = allMarkersForCluster.concat(markers);
  });

  const clusterObj = {
    url: generateSvgCluster(styleApi.colors.brand2.split(','),true),
    textColor: 'white',
    textSize: 20,
    width: 48,
    height: 44,
  };
  const clustermapData = {
    ignoreHidden: true,
    styles: [
      clusterObj,
      clusterObj,
      clusterObj,
      clusterObj,
      clusterObj
    ]
  };

  mapData.clusters = new MarkerClusterer(map, allMarkersForCluster, clustermapData);
}

function addStaticMarkers () {
  Object.values(mapData.staticMarkers).forEach(marker =>{
    // const zIndex = google.maps.Marker.MAX_ZINDEX + 100;
    const zIndex = 1;
    const staticMarker = addMarker(marker, 55, zIndex, false);
    
    // переход в 3д вид по клику метки
    staticMarker.addListener('click', () => {
      map.setCenter(staticMarker.getPosition())
      setTimeout(() => {
        let zoom = map.getZoom()
        document.querySelector('[data-menu-item="3dModel"]').click()
        transferToBuilding(zoom)
      }, 200)
    })
    
    mapData.staticMarkersOnMap.push(staticMarker);
  });
}

export const centerMarker = ()=>{
  if (mapData?.staticMarkersOnMap?.length!==0){
    map?.setCenter(mapData.staticMarkersOnMap[0].getPosition())
  }
}

function addPoiMarkers () {
  mapData.allPoiMarkers = {};
  mapData.allPoiMarkersWithoutCategory = [];
  Object.entries(mapData.filteredMarkers).forEach(([category,markers]) =>{
    mapData.allPoiMarkers[category] = [];
    markers.forEach(marker =>{
      const buildedMarker = addMarker(marker);
      buildedMarker.data = {
        'address': marker.address,
        'distanceToPoint': marker.distanceToPoint,
        'timeToPoint': marker.timeToPoint,
        'phone': marker.phone,
        'customPhone': marker.customPhone,
        'googleMapsID': marker.googleMapsID,
        'internationalPhone': marker.internationalPhone,
        'webSiteUrl': marker.webSiteUrl,
        'infoWindowImg': marker.infoWindowImg,
        'markerDescription': marker.markerDescription,
        'sendPhotoRequest': marker.sendPhotoRequest,
        'panoramaError': marker.panoramaError,
        'routeResponce': marker.routeResponce,
        'categoryIconMenuName': marker.categoryIconMenuName,
      };
      addPoiListener(buildedMarker);
      mapData.allPoiMarkers[category].push(buildedMarker);
      mapData.allPoiMarkersWithoutCategory.push(buildedMarker);
    });
  });
}

function addMarker (marker, staticLabelPosY, zIndex = 1, addLongClass = true ) {
  const title = marker.title;
  const labelPosY = title.length > 15 ? staticLabelPosY || 65 : staticLabelPosY || 55;
  const pos = new google.maps.LatLng(marker.lat, marker.lng);
  const iconImg = new google.maps.MarkerImage();
  iconImg.url = marker.markerIcon;
  iconImg.labelOrigin = new google.maps.Point(18, labelPosY);

  const newMarker = new google.maps.Marker({
    title: title,
    position: pos,
    label: {
      color: marker.color ? marker.color : '#000000',
      text: title,
      fontWeight: '700',
      textAlign: 'center',
      className: title.length > 15 && addLongClass ? 'long__label-text marker__label' : 'marker__label',
    },
    category: marker.category,
    cluster_ic: marker.clusterIcon,
    category_title: marker.categoryTitle,
    category_zoom: marker.categoryZoom,
    category_ic: marker.categoryImg,
    map: map,
    icon: iconImg,
    animation: google.maps.Animation.DROP,
    zIndex: zIndex,
    color: marker.color,
  });

  return newMarker;
}

function addPoiToCategory (poiData, poiCategories) {
  poiCategories.forEach(category =>{
    category.data =[];
    poiData.forEach(poi =>{
      if (Number(category.categoryId) === poi.categoryId){
        category.data.push(poi);
      }
    });
  });
}

export async function loadIcon (name) {
  const icon = await fetch(`/img/icons/poi/${name}.svg`);
  const text = await icon.text();

  return text;
}

async function preparePoiData (objectToAssign, poiCategories) {
  const poiWithCategory ={};
  const poiPlug = await loadIcon('POI__PLUG');

  return new Promise(resolve => {

    poiCategories.forEach( async (category) =>{
      if (category.data.length > 0){
        const icon_f = await loadIcon(category.icon);
        const icon_i = await loadIcon(category.iconMenu);
        const categoryName = category.name.filter(elName=>elName.lang === lang)[0].value;
        poiWithCategory[categoryName] =[];

        category.data.forEach(catData =>{
          const dataName = catData.name.filter(elName=>elName.lang === lang)[0].value;
          const description = catData.description.filter(elName=>elName.lang === lang)[0].value;
          const address = catData.address.filter(elName=>elName.lang === lang)[0].value;
          const obj = {
            'category': categoryName,
            'title': dataName,
            'lat': catData.latitude,
            'lng': catData.longitude,
            'color': category.color,
            'categoryIconMenuName': category.iconMenu,
            'markerIcon': generateSvg(icon_f,'#C0C0C0', category.color),
            'clusterIcon': generateSvgCluster(styleApi.colors.brand1.split(','),true),
            'categoryTitle': categoryName,
            'categoryZoom': 16,
            'categoryImg': generateSvg(icon_i),
            'infoWindowImg': generateSvg(poiPlug),
            'markerDescription': description,
            'address': address,
            'distanceToPoint': catData.distanceToPoint,
            'timeToPoint': catData.timeToPoint,
            'phone': catData.phone,
            'customPhone': catData.customPhone,
            'googleMapsID': catData.googleMapsID,
            'internationalPhone': catData.internationalPhone,
            'sendPhotoRequest': false,
            'panoramaError': false,
            'webSiteUrl': catData.url,
            'routeResponce': {
              'WALKING': null,
              'DRIVING': null,
              'BICYCLING': null,
            }
          };
          poiWithCategory[categoryName].push(obj);
        });
      }
    });
    const interval = setInterval(()=>{
      if (poiCategories.length === Object.keys(poiWithCategory).length){
        clearInterval(interval);
        resolve (Object.assign(objectToAssign,poiWithCategory));
      }
    },100);
  });

}

let _panoramaOrbit =null;
let _panoramaMap = null;

export function resetPanoramaService () {
  return;
  _panoramaOrbit = null;
  _panoramaMap = null;
}

export function panoramaOrbitResize () {

  // update orbit panorama
  if (_panoramaOrbit && document.querySelector('.map__panorama__orbit.map__panorama__orbit__show') ){
    _panoramaOrbit.setVisible(true);
  }

  // update map panorama
  if (_panoramaMap && document.querySelector('.map__panorama.map__panorama__show') ){
    _panoramaMap.setVisible(true);
  }

}

export function getStreetPanorama (marker,containerId,orbit) {
  if (marker.data.panoramaError){

    Notiflix.Notify.merge({
      position: isDesktopMode() ? 'left-top' : (dir === 'ltr') ? 'right-top' : 'left-top',
      rtl: (dir !== 'ltr'),
      timeout: 2000
    });
    Notiflix.Notify.failure('Street View data not found for this location');

    return;
  }

  const request ={
    location: marker.getPosition(),
    radius: 50
  };

  const panoramaContainer = containerId ? document.getElementById(containerId) : document.createElement('div');
  const service = new google.maps.StreetViewService();

  if (_panoramaOrbit === null && orbit) {
    _panoramaOrbit = new google.maps.StreetViewPanorama(panoramaContainer,{
      motionTracking: true,
      motionTrackingControl: true,
      linksControl: true,
      fullscreenControl: false,
      panControl: true,
      enableCloseButton: false,
    });
  }

  if (_panoramaMap === null && !orbit) {
    _panoramaMap = new google.maps.StreetViewPanorama(panoramaContainer,{
      motionTracking: true,
      motionTrackingControl: true,
      linksControl: true,
      fullscreenControl: false,
      panControl: true,
      enableCloseButton: false,
    });
  }


  const panorama = orbit ? _panoramaOrbit : _panoramaMap;

  return new Promise(resolve =>{
    service.getPanorama(request, (data, status) =>{
      if (status === 'OK'){
        const location = data.location;
        panorama.setPano(location.pano);
        panorama.setPov({
          heading: 0,
          pitch: 0,
        });

        if (!orbit){
          panoramaContainer.classList.add('map__panorama__show');
        } else {
          panoramaContainer.classList.add('panorama__wrapper__orbit');
          panoramaContainer.setAttribute('id','orbitPanorama');
          let mainOrbitContainer = document.querySelector('.map__panorama__orbit');
          if (!mainOrbitContainer){
            addCloseBtnInStreetView(panoramaContainer);
            mainOrbitContainer = createHtmlElement(document.body,'','div',['map__panorama__orbit']);
            mainOrbitContainer.appendChild(panoramaContainer);
          }
          pageResize(mainOrbitContainer);
          mainOrbitContainer.classList.add('map__panorama__orbit__show');
          renderUpdateValuesOnDemand(true);
          toggleBackBtnInDesktopMode('show');
        }
        hideAllDefaultMapLinks(panoramaContainer);
        panorama.setVisible(true);
        resolve(panorama);
      } else {
        marker.data.panoramaError = true;
        // resetPanoramaService();

        Notiflix.Notify.merge({
          position: isDesktopMode() ? 'left-top' : (dir === 'ltr') ? 'right-top' : 'left-top',
          rtl: (dir !== 'ltr'),
          timeout: 2000
        });
        Notiflix.Notify.failure('Street View data not found for this location')
        // showMsg('Street View data not found for this location.');
      }
    });
  });
}

export function addCloseBtnInStreetView (panoramaMainContainer) {
  const btn = createHtmlElement(panoramaMainContainer,'','button',['panorama__close-btn','icon-close']);
  btn.addEventListener('click', ()=> panoramaCloseHandler(panoramaMainContainer));
}

export function panoramaCloseHandler (panoramaMainContainer) {
  panoramaMainContainer.classList.remove('map__panorama__show');
  const panorama = panoramaMainContainer.querySelector('.gm-style');

  if (_panoramaMap){
    _panoramaMap.setVisible(false)
  }
  
  if (panorama) {
    //panorama.remove();
  }

  const orbitPanorama = document.querySelector('.map__panorama__orbit__show');

  if (orbitPanorama){
    //orbitPanorama.remove();
    // _panoramaOrbit.setVisible(false);
    // orbitPanorama.style.display = 'none'
    orbitPanorama.classList.remove('map__panorama__orbit__show');
    const rightNavBarIsShowed = document.querySelector('.right-nav-bar.showed');
    renderUpdateValuesOnDemand(false);
    autoRotateTimerAction('update');

    rightNavBarIsShowed && hideRightNavBar();
  }

}

export function closePanorama () {
  const container = document.querySelector('.map__panorama__show');
  if (container){
    panoramaCloseHandler(container);
  }
}

export function isPanoramaActive () {
  return Boolean(document.querySelector('.map__panorama__show'));
}

function showMsg (msgText) {
  const msg = document.querySelector('.map__msg');
  if (msgText){
    msg.textContent = msgText;
    msg.classList.add('show__msg');
    setTimeout(()=>{
      showMsg();
    },2000);
  } else {
    msg.classList.remove('show__msg');
  }
}

function addMapControls () {
  const mainContainer = document.querySelector('.'+canvasClass);
  const goHomeBtn = createHtmlElement(mainContainer,'','div',['map__go-home__btn']);
  const homeBtnImg = createHtmlElement(goHomeBtn,'','img',['home-btn__img']);
  homeBtnImg.src ='#';
  homeBtnImg.alt ='home button';
  const menuBtn = createHtmlElement(mainContainer,'','div',['menu-btn']);
  const panorama = createHtmlElement(mainContainer,'','div',['map__panorama']);
  panorama.setAttribute('id','panorama');
  addCloseBtnInStreetView(panorama);
  const errorMsg = createHtmlElement(mainContainer,'Street View data not found for this location.','div',['map__msg']);

  if (isMobile){
    addMapMobileControls(mainContainer);
    return;
  }
  const asideMenuContainer = createHtmlElement(mainContainer,'','div',['aside-menu__container','open-aside-menu']);
  const asideMenuWrapper = createHtmlElement(asideMenuContainer,'','div',['aside-menu__wrapper']);
  // const closeAsideMenuBtn = createHtmlElement(asideMenuWrapper,'','div',['aside-menu__close-btn']);
  // const closeBtnImg = createHtmlElement(closeAsideMenuBtn,'','img',['aside-menu__close-btn__img']);
  // closeBtnImg.src = generateSvg(projectIcons,'CLOSE__BTN','white',styleApi.colors.brand1.split(','),true);
  //Aside map section
  const mapTypeContainer = createHtmlElement(asideMenuWrapper,'','div',['aside-menu__type-container']);
  const mapTypeTitle = createHtmlElement(mapTypeContainer,changeLangToCurrent('Map'),'h3',['aside-menu__map-type__title']);
  const mapTypeTriggersContainer = createHtmlElement(mapTypeContainer,'','div',['aside-menu__map-type-trigger__container']);
  // const roadContainer = createHtmlElement(mapTypeTriggersContainer,'','div',['aside-menu__map-type','active__map-type']);
  // roadContainer.dataset.mapType ='roadmap';
  // const roadIcon = createHtmlElement(roadContainer,'','div',['aside-menu__road-icon']);
  // roadIcon.dataset.mapType ='roadmap';
  // const roadText = createHtmlElement(roadContainer,changeLangToCurrent('2D map'),'span',['aside-menu__road-text']);
  // roadText.dataset.mapType ='roadmap';
  // const satelliteContainer = createHtmlElement(mapTypeTriggersContainer,'','div',['aside-menu__map-type']);
  // satelliteContainer.dataset.mapType ='satellite';
  // const satelliteIcon = createHtmlElement(satelliteContainer,'','div',['aside-menu__satellite-icon']);
  // satelliteIcon.dataset.mapType ='satellite';
  // const satelliteText = createHtmlElement(satelliteContainer,changeLangToCurrent('Satellite'),'span',['aside-menu__satellite-text']);
  // satelliteText.dataset.mapType ='satellite';

  const mapToggle = createHtmlElement(mapTypeTriggersContainer,'','div',['mini-map__toggle']);
  const mapName = createHtmlElement(mapToggle,changeLangToCurrent('Satellite'),'span',['mini-map__toggle__name']);
  mapName.dataset.roadmapText = changeLangToCurrent('Satellite');
  mapName.dataset.satelliteText = changeLangToCurrent('mapMode');
  mapToggle.dataset.mapType = 'roadmap';
  //Aside Neighborhood section
  const filterContainer = createHtmlElement(asideMenuWrapper,'','div',['aside-menu__filter-container']);
  const filterTitle = createHtmlElement(filterContainer,changeLangToCurrent('Area of interest'),'h3',['aside-menu__filter__title']);
  const allPointsOfInterestContainer = createHtmlElement(filterContainer,'','div',['aside-menu__filter-points']);

  addFilter(allPointsOfInterestContainer);

  const streetNameContainer = createHtmlElement(asideMenuWrapper,'','div',['aside-menu__street-name__wrapper']);
  const streetName = createHtmlElement(streetNameContainer,changeLangToCurrent('Show street names'),'span',['aside-menu__street-name__text']);
  const streetToggle = createHtmlElement(streetNameContainer,'','input',['aside-menu__street__input']);
  streetToggle.name = 'toggle';
  streetToggle.id = 'streetToggle';
  streetToggle.type = 'checkbox';
  streetToggle.checked = true;
  const streetToggleLabel = createHtmlElement(streetNameContainer,'','label',['aside-menu__street-toggle__label']);
  streetToggleLabel.setAttribute('for',streetToggle.id);

  streetToggle.addEventListener('change', ()=> streetNameToggle(streetToggle));
  mapTypeTriggersContainer.addEventListener('click', (e) => changeMapTypeHandler(e.target,asideMenuContainer));
  allPointsOfInterestContainer.addEventListener('click', (e) => filterHandler(e.target,asideMenuContainer));
  menuBtn.addEventListener('click',() => menuBtnHandler(asideMenuContainer));
  // closeBtnImg.addEventListener('click', () => menuBtnHandler(asideMenuContainer));
}

function addMapMobileControls (mainContainer) {
  const menuContainer = createHtmlElement(mainContainer,'','div',['mobile__menu-container']);
  const mobileInfoWindow = createHtmlElement(mainContainer,'','div',['mobile__snazzy-window']);
  const menuWrapper = createHtmlElement(menuContainer,'','div',['mobile__menu-wrapper']);
  const menuItems = createHtmlElement(menuWrapper,'','ul',['mobile__menu-items']);
  const menuItemNeig = createHtmlElement(menuItems, changeLangToCurrent('Area of interest'),'li',['mobile__menu-item']);
  menuItemNeig.dataset.tab='Neighborhood';
  const menuNeigLands = createHtmlElement(menuItems,'','li',['mobile__menu-item__landscape','landscape','neighborhood__landscape']);
  menuNeigLands.dataset.tab='Neighborhood';
  const menuItemMap = createHtmlElement(menuItems, changeLangToCurrent('Map'),'li',['mobile__menu-item']);
  menuItemMap.dataset.tab='Map';
  const menuItemMapLands = createHtmlElement(menuItems,'','li',['mobile__menu-item__landscape','landscape','map__landscape']);
  menuItemMapLands.dataset.tab='Map';

  if (isPortraitMode()){
    menuItemNeig.classList.add('active-menu-tab');
  } else {
    menuNeigLands.classList.add('active-menu-tab');
  }

  const tabsContainer = createHtmlElement(menuWrapper,'','div',['mobile__tabs-container']);
  const tabNeig = createHtmlElement(tabsContainer,'','div',['mobile__tab-content','active-tab']);
  tabNeig.dataset.tab='Neighborhood';
  const tabMap = createHtmlElement(tabsContainer,'','div',['mobile__tab-content']);
  tabMap.dataset.tab='Map';
  const filterContainer = createHtmlElement(tabNeig,'','div',['mobile-menu__filter-container']);
  const mapTypeContainer = createHtmlElement(tabMap,'','div',['aside-menu__type-container', 'mobile-menu__map-container']);
  const mapTypeTriggersContainer = createHtmlElement(mapTypeContainer,'','div',['mobile-menu__map-type-trigger__container']);

  // const roadContainer = createHtmlElement(mapTypeTriggersContainer,'','div',['aside-menu__map-type','mobile-menu__map-type','active__map-type']);
  // roadContainer.dataset.mapType ='roadmap';
  // const roadIcon = createHtmlElement(roadContainer,'','div',['aside-menu__road-icon']);
  // roadIcon.dataset.mapType ='roadmap';
  // const roadText = createHtmlElement(roadContainer,changeLangToCurrent('2D map'),'span',['aside-menu__road-text']);
  // roadText.dataset.mapType ='roadmap';
  // const satelliteContainer = createHtmlElement(mapTypeTriggersContainer,'','div',['aside-menu__map-type','mobile-menu__map-type']);
  // satelliteContainer.dataset.mapType ='satellite';
  // const satelliteIcon = createHtmlElement(satelliteContainer,'','div',['aside-menu__satellite-icon']);
  // satelliteIcon.dataset.mapType ='satellite';
  // const satelliteText = createHtmlElement(satelliteContainer,changeLangToCurrent('Satellite'),'span',['aside-menu__satellite-text']);
  // satelliteText.dataset.mapType ='satellite';

  const mapToggle = createHtmlElement(mapTypeTriggersContainer,'','div',['mini-map__toggle']);
  const mapName = createHtmlElement(mapToggle,changeLangToCurrent('Satellite'),'span',['mini-map__toggle__name']);
  mapName.dataset.roadmapText = changeLangToCurrent('Satellite');
  mapName.dataset.satelliteText = changeLangToCurrent('mapMode');
  mapToggle.dataset.mapType = 'roadmap';

  addFilter(filterContainer);

  // const streetNameContainer = createHtmlElement(tabNeig,'','div',['aside-menu__street-name__wrapper']);
  const streetNameContainer = createHtmlElement(filterContainer,'','div',['aside-menu__street-name__wrapper']);
  const streetName = createHtmlElement(streetNameContainer,changeLangToCurrent('Show street names'),'span',['aside-menu__street-name__text']);
  const streetToggle = createHtmlElement(streetNameContainer,'','input',['aside-menu__street__input']);
  streetToggle.name = 'toggle';
  streetToggle.id = 'streetToggle';
  streetToggle.type = 'checkbox';
  streetToggle.checked = true;
  const streetToggleLabel = createHtmlElement(streetNameContainer,'','label',['aside-menu__street-toggle__label']);
  streetToggleLabel.setAttribute('for',streetToggle.id);

  streetToggle.addEventListener('change', ()=> streetNameToggle(streetToggle));

  const menuBtn = mainContainer.querySelector('.menu-btn');
  menuBtn.addEventListener('click',() => menuBtnHandler(menuContainer));
  menuItems.addEventListener('click',(e) => menuItemsHandler(e.target));
  mapTypeTriggersContainer.addEventListener('click', (e) => changeMapTypeHandler(e.target,menuContainer));
  filterContainer.addEventListener('click', (e) => filterHandler(e.target,menuContainer));

  setMenuTouchEvents();
}

function menuItemsHandler (selectedItem) {
  if (selectedItem.dataset.tab){
    const dataSet = selectedItem.dataset.tab;
    const activeMenuItem = document.querySelector('.active-menu-tab');
    const activeTab = document.querySelector('.active-tab');
    const selectedTab = document.querySelector('.mobile__tab-content[data-tab="'+ dataSet +'"]');

    activeMenuItem.classList.remove('active-menu-tab');
    selectedItem.classList.add('active-menu-tab');
    activeTab.classList.remove('active-tab');
    selectedTab.classList.add('active-tab');
    updateHomeButton();
  }
}


function changeDocumentStyleProperty (idStyleSheet, selector, property, value) {
  const styleSheet = document.getElementById(idStyleSheet).sheet;
  Object.values(styleSheet.cssRules).forEach(rule =>{
    if (rule.selectorText === selector){
      rule.style[property] = value;
    }
  });
}

function changeMarkersLabelColor (color, useMarkerColor = true) {
  mapData.staticMarkersOnMap[0].label.color = color;
  mapData.staticMarkersOnMap[0].setMap(null);
  mapData.staticMarkersOnMap[0].setMap(map);
  mapData.allPoiMarkersWithoutCategory.forEach(marker =>{
    marker.label.color = useMarkerColor ? marker.color : color;
  });


 if (mapData.filterResault.length){
   mapData.filterResault.forEach(marker =>{
     marker.label.color = useMarkerColor ? marker.color : color;
   });
   filterMarkers('filter',false);
 } else {
   filterMarkers('all',false);
 }

}

function changeMapTypeHandler (selectedMapType,filterContainer) {
  if (selectedMapType.dataset.mapType){
    const mapTypeTextElement = selectedMapType.querySelector('.mini-map__toggle__name');
    let type;
    switch (selectedMapType.dataset.mapType) {
      case 'roadmap':
        mapTypeTextElement.textContent = mapTypeTextElement.dataset.satelliteText;
        map.setMapTypeId('satellite');
        changeMarkersLabelColor('#ffffff', false);
        changeDocumentStyleProperty('basicStyle','.marker__label','filter','drop-shadow(0px 0px 1px black)' +
          ' drop-shadow(0px 0px 4px black)');
        selectedMapType.dataset.mapType = 'satellite';
        break;
      case 'satellite':
        mapTypeTextElement.textContent = mapTypeTextElement.dataset.roadmapText;
        map.setMapTypeId('roadmap');
        changeMarkersLabelColor('#000000');
        changeDocumentStyleProperty('basicStyle','.marker__label','filter','none');
        selectedMapType.dataset.mapType = 'roadmap';
        break;
    }

    // selectedMapType.dataset.mapType = type;

    // const type = selectedMapType.dataset.mapType;
    // const activeMapType = document.querySelector('.active__map-type');
    // activeMapType.classList.remove('active__map-type');
    // const clickedMapTypeContainer = document.querySelector('.aside-menu__map-type[data-map-type="'+ type +'"]');
    // clickedMapTypeContainer.classList.add('active__map-type');
    // map.setMapTypeId(type);
    // if (type === 'roadmap'){
    //   changeMarkersLabelColor('#000000');
    //   changeDocumentStyleProperty('basicStyle','.marker__label','filter','none');
    // } else {
    //   changeMarkersLabelColor('#ffffff', false);
    //   changeDocumentStyleProperty('basicStyle','.marker__label','filter','drop-shadow(0px 0px 1px black)' +
    //     ' drop-shadow(0px 0px 4px black)');
    // }
    menuBtnHandler(filterContainer);
  }
}

function filterHandler (selectedFilter, filterContainer) {
  if (selectedFilter.dataset.filterCategory){
    const category = selectedFilter.dataset.filterCategory;
    if (category !== 'All'){
      const categoryMarkers = mapData.allPoiMarkers[category];
      mapData.filterResault.push(...categoryMarkers);
      mapData.filterResault = [...new Set(mapData.filterResault)];


      if (mapData.filterResault.length){

        if (selectedFilter.classList.contains('pressed-btn')){
          const sorted = mapData.filterResault.filter(marker => marker.category !== category);
          mapData.filterResault = sorted;
        }

        closePrevInfoWindow();
        setActiveFilter(selectedFilter);
        filterMarkers('filter',false);
        // menuBtnHandler(filterContainer);
      }
    } else {
      closePrevInfoWindow();
      setActiveFilter();
      filterMarkers('all');
      // menuBtnHandler(filterContainer);
    }
  }
}

function filterMarkers (action, animate = true) {
  switch (action) {
    case 'filter':
      mapData.clusters.clearMarkers();
      mapData.filterResault.forEach(marker => {
        marker.setAnimation(google.maps.Animation.DROP);
      });
      mapData.clusters.addMarkers(mapData.filterResault);
      mapData.clusters.repaint();
      // map.setZoom(mapData.mapSettings.zoom);
      animate && smoothlyAnimatePanTo(map, startPoint);
      break;
    case 'all':
      mapData.clusters.clearMarkers();
      mapData.allPoiMarkersWithoutCategory.forEach(marker =>{
        marker.setAnimation(google.maps.Animation.DROP);
      });
      mapData.clusters.addMarkers(mapData.allPoiMarkersWithoutCategory);
      mapData.clusters.repaint();
      mapData.filterResault = [];
      // map.setZoom(mapData.mapSettings.zoom);
      animate && smoothlyAnimatePanTo(map, startPoint);
      break;
  }
}

function setActiveFilter (newFilterCategory) {
  const defaultCategory = document.querySelector('.filter__btn[data-filter-category="All"]');

  if (newFilterCategory){
    defaultCategory.classList.remove('pressed-btn');

    if (newFilterCategory.tagName === 'IMG'){
      newFilterCategory = newFilterCategory.parentElement;
    }

    if (newFilterCategory.classList.contains('pressed-btn')){
      newFilterCategory.classList.remove('pressed-btn');
      newFilterCategory.style.removeProperty('border-color');

      return;
    }

    newFilterCategory.classList.add('pressed-btn');
    newFilterCategory.style.borderColor = newFilterCategory.dataset.activeBtnColor;
  } else {
    const allActiveCategories = document.querySelectorAll('.filter__btn.pressed-btn');
    for (let category of allActiveCategories){
      category.classList.remove('pressed-btn');
      category.style.removeProperty('border-color');
    }
    defaultCategory.classList.add('pressed-btn');
  }
}

function addFilter (domContainer) {
  const allBtn = createHtmlElement(domContainer,changeLangToCurrent('All'),'button',['filter__btn','pressed-btn','button']);
  allBtn.dataset.filterCategory = 'All';
  const allBtnImg = createHtmlElement(allBtn,'','div',['filter__poi-icon','icon-map-pin-outline']);
  allBtnImg.dataset.filterCategory = 'All';

  Object.entries(mapData.allPoiMarkers).forEach(([category,markers]) =>{
    const btn = createHtmlElement(domContainer,category,'button',['filter__btn','button']);
    btn.dataset.filterCategory = category;
    btn.dataset.activeBtnColor = markers[0].color;
    const img = createHtmlElement(btn,'','img',['filter__poi-icon']);
    img.src = markers[0].category_ic;
    img.dataset.filterCategory = category;
  });
}

export function openMiniCard (cardContainer = document.querySelector('.mobile__snazzy-window'),changeBtnPosition = true,orbit = false) {
  if (!cardContainer || !cardContainer.firstElementChild){
    return;
  }
  cardContainer.classList.add('open-mobile-card');
  const content = cardContainer.querySelector('.snazzy-content__container');
  const titleContainer = content.querySelector('.snazzy-content__title-container').getBoundingClientRect().height;
  const infoContainer = content.querySelector('.snazzy-content__container-info').getBoundingClientRect().height;
  const btnHeight = document.querySelector('.snazzy-contnet__btns-container').getBoundingClientRect().height;
  const photoHeight = document.querySelector('.snazzy-content__photo-container').getBoundingClientRect().height;
  // card.style.maxHeight = titleContainer + photoHeight + infoContainer + btnHeight + 'px';
  const height = cardContainer.getBoundingClientRect().height;
  // const top = orbit ? 0 : settingsData.widgetsPaddingTop;
  const top = 0;

  if (isPortraitMode()){
    content.style.maxHeight =  titleContainer + photoHeight + infoContainer + btnHeight + 'px';
    content.style.height = window.innerHeight - top + 'px';
    // changeMenuBtnPosition(height);
    changeBtnPosition && changeMenuBtnPosition(titleContainer + photoHeight + infoContainer + btnHeight);
  } else {
    content.style.maxHeight = window.innerHeight - top + 'px';
    content.style.height = window.innerHeight - top + 'px';
    content.style.width = window.innerWidth+'px';
    content.style.maxWidth = '358px';
  }
}

function menuBtnHandler (asideMenu) {
  if (isMobile){
    const isCardOpened = whichCardIsOpen();
    if (isCardOpened){
      closePrevInfoWindow();
    }
    if (asideMenu){
      asideMenu.classList.toggle('open-mobile-menu');
    }
  }
  // else {
    // if (asideMenu){
    //   // asideMenu.classList.toggle('open-aside-menu');
    // }
  // }
  updateHomeButton();
}

function changeMenuBtnPosition (height = 0) {
  const btn = document.querySelector('.menu-btn');
  if (height > 0){
    btn.style.bottom = height + 24 + 'px';
  } else {
    btn.style.removeProperty('bottom');
  }
}

function hideAllDefaultMapLinks (container = document) {
  const interval = setInterval(()=> {
    const links = container.querySelectorAll('a[rel="noopener"]');
    if (links.length > 0) {
      clearInterval(interval);
      links.forEach(link => {
        const googleLogo = container.querySelector('a[rel="noopener"][aria-label*="Google"] img');
        if (googleLogo) {
          googleLogo.classList.add('google-logo__image');
        } else {
          link.style.display = 'none';
        }
      });
    }
  },100);
}

export function poiOrientationHandler () {
  // const orientationInterval = setInterval(()=>{
  //   if (isPortrait !== isPortraitMode()){
  //     clearInterval(orientationInterval);
      if (apiError) return;

      isPortrait = isPortraitMode();
      setActiveMenuTabInLanscapeMode();
      updateMapHeight();
      setMenuTouchEvents();
      setMobileFullscreenCardSize();
      setSwipeMiniCard();
      setMobileMiniCardSize();
      pageResize(document.querySelector('.widget__container[data-menu-item="map"]'));
    // }
  // },100);
}

export function mapUpdate () {
  lang = getCurrentLang();
  dir = getCurrentLangDirection();
  isPortrait = isPortraitMode();
  const scriptsLink = document.head.querySelectorAll('script');
  scriptsLink.forEach(script =>{
    if (script.src.startsWith('https://maps.googleapis.com')){
      script.remove();
    }
  });

  delete window.google;
  removeScript('marker');
  removeScript('snazzy');
  // removeStyles();
  delete window.SnazzyInfoWindow;
  const mapContainer = document.querySelector('.' + canvasClass);
  if (!mapContainer){
    return;
  }
  mapContainer.remove();
  swipeMenu && swipeMenu.removeEventListeners();
  swipeMiniCard && swipeMiniCard.removeEventListeners();
  swipeMenu && swipeMenu.stop();
  swipeMiniCard && swipeMiniCard.stop();
  swipeMenu = undefined;
  swipeMiniCard = undefined;

  const scriptInterval = setInterval(()=>{
    addScripts();
    if (scriptsChecker()){
      clearInterval(scriptInterval);
      initMap(poiSettings, poiData, poiCategories).then(()=> poiOrbitCardSwitchingLang());
      pageResize(document.querySelector('.widget__container[data-menu-item="map"]'));
    }
  },200);

  //
  // // document.querySelector('.' + canvasClass).remove();
  // //
  // const scriptInterval = setInterval(()=>{
  //   console.log('check');
  //   addScripts();
  //   if (scriptsChecker()){
  //     clearInterval(scriptInterval);
  //     map = new google.maps.Map(mapMainContainer, mapmapData);
  //
  //     // initMap(poiSettings, poiData, poiCategories);
  //     // pageResize(document.querySelector('.' + canvasClass).parentElement);
  //   }
  // },200);

}

export function setMobileMiniCardSize (cardContainer = document.querySelector('.mobile__snazzy-window')) {
  if (!mapData.snazzyWindow.length){
    return;
  }

  const cardMode = whichCardIsOpen();
  if (cardMode === 'fullscreen'){
    return;
  }

  const content = cardContainer.querySelector('.snazzy-content__container');
  const titleContainer = content.querySelector('.snazzy-content__title-container').getBoundingClientRect().height;
  const infoContainer = content.querySelector('.snazzy-content__container-info').getBoundingClientRect().height;
  const btnHeight = document.querySelector('.snazzy-contnet__btns-container').getBoundingClientRect().height;
  const photoHeight = document.querySelector('.snazzy-content__photo-container').getBoundingClientRect().height;
  // card.style.maxHeight = titleContainer + photoHeight + infoContainer + btnHeight + 'px';
  const height = cardContainer.getBoundingClientRect().height;
  // const top = settingsData.widgetsPaddingTop;
  const top = 0;

  if (isPortraitMode()){
    content.style.maxHeight =  titleContainer + photoHeight + infoContainer + btnHeight + 'px';
    content.style.height = window.innerHeight - top + 'px';
    content.style.width = '100%';
    content.style.maxWidth = 'unset';
    changeMenuBtnPosition(titleContainer + photoHeight + infoContainer + btnHeight);
  } else {
    content.style.maxHeight = window.innerHeight - top + 'px';
    content.style.height = window.innerHeight - top + 'px';
    content.style.width = window.innerWidth+'px';
    content.style.maxWidth = '358px';
    changeMenuBtnPosition();
  }

  // if (isPortrait){
  //   const content = cardContainer.querySelector('.snazzy-content__container');
  //   const height = calcElementHeight('.snazzy-content__container');
  //   content.style.maxHeight = height + 'px';
  //   content.style.height = window.innerHeight + 'px';
  //   content.style.width = '100%';
  //   content.style.maxWidth = 'unset';
  //   changeMenuBtnPosition(height);
  // } else {
  //   const content = cardContainer.querySelector('.snazzy-content__container');
  //   content.style.maxHeight = window.innerHeight + 'px';
  //   content.style.height = window.innerHeight + 'px';
  //   content.style.width = window.innerWidth+'px';
  //   content.style.maxWidth = '358px';
  //   changeMenuBtnPosition();
  // }
}

function calcElementHeight (querySelector) {
  let totalSize = 0;

  const element = document.querySelector(querySelector);
  for (let child of element.children){
    totalSize += child.getBoundingClientRect().height;
  }

  return totalSize;
}

function setMenuTouchEvents () {
  const menuWrapper = document.querySelector('.mobile__menu-wrapper');
  if (!menuWrapper){
    return;
  }

  if (!swipeMenu){
    swipeMenu = new Swipe(menuWrapper);
  }

  if (isPortrait){
    switch (dir) {
      case 'rtl':
        swipeMenu.stop();
        swipeMenu.onLeft(() => menuItemsHandler(document.querySelector('.mobile__menu-item[data-tab="Neighborhood"]')));
        swipeMenu.onRight(() => menuItemsHandler(document.querySelector('.mobile__menu-item[data-tab="Map"]')));
        swipeMenu.onDown(() => menuBtnHandler(document.querySelector('.mobile__menu-container')));
        swipeMenu.run();
        break;
      case 'ltr':
        swipeMenu.stop();
        swipeMenu.onLeft(() => menuItemsHandler(document.querySelector('.mobile__menu-item[data-tab="Map"]')));
        swipeMenu.onRight(() => menuItemsHandler(document.querySelector('.mobile__menu-item[data-tab="Neighborhood"]')));
        swipeMenu.onDown(() => menuBtnHandler(document.querySelector('.mobile__menu-container')));
        swipeMenu.run();
        break;
    }

  } else {
    switch (dir) {
      case 'rtl':
        swipeMenu.stop();
        swipeMenu.onRight(()=>menuBtnHandler(document.querySelector('.mobile__menu-container')));
        swipeMenu.onDown(() => menuItemsHandler(document.querySelector('.mobile__menu-item__landscape[data-tab="Map"]')));
        swipeMenu.onUp(()=> menuItemsHandler(document.querySelector('.mobile__menu-item__landscape[data-tab="Neighborhood"]')));
        swipeMenu.run();
        break;
      case 'ltr':
        swipeMenu.stop();
        swipeMenu.onLeft(() => menuBtnHandler(document.querySelector('.mobile__menu-container')));
        swipeMenu.run();
        break;
    }
  }
}

function updateMapHeight () {
  const mapContainer = document.querySelector('.'+canvasClass);
  mapContainer.style.maxHeight = window.innerHeight + 'px';
}

function setActiveMenuTabInLanscapeMode () {
  const activeTab = document.querySelector('.active-menu-tab');
  if (activeTab){
    activeTab.classList.remove('active-menu-tab');

    if (activeTab.classList.contains('landscape')){
      const tab = document.querySelector('.mobile__menu-item[data-tab="'+activeTab.dataset.tab+'"]');
      tab.classList.add('active-menu-tab');
    } else {
      const landscapeTab = document.querySelector('.mobile__menu-item__landscape[data-tab="'+activeTab.dataset.tab+'"]');
      landscapeTab.classList.add('active-menu-tab');
    }
  }
}

function streetNameToggle (toggleElement) {
  const showStreetsName = toggleElement.checked;
  map.styles.find((style,index) =>{
    if (style.featureType === 'road'){
      style.stylers[0].visibility = showStreetsName ? 'on' : 'off';
      map.setOptions({ styles: map.styles });
    }
  });
}

export function generateSvg (icon,color,newColor,convertRgbaToHex = false) {
  let iconSvg;

  if (icon){
    if (color && newColor){
      if (convertRgbaToHex){
        newColor = rgbaToHexA(newColor);
      }
      const regExp = new RegExp(color,'g');
      iconSvg = icon.replace(regExp,newColor);
    } else {
      iconSvg = icon;
    }
    const encoded = window.btoa(iconSvg);

    return ('data:image/svg+xml;base64,' + encoded);
  } else {
    return generateSvgCluster(color|| '#C0C0C0');
  }
}


function generateSvgCluster (color, needConvert = false) {
  if (needConvert){
    color = rgbaToHexA(color);
  }
  const encoded = window.btoa('<svg width="48" height="44" viewBox="0 0 48 44" fill="none" xmlns="http://www.w3.org/2000/svg">' +
    '<path fill-rule="evenodd" clip-rule="evenodd" d="M40.3094 26.3754C41.394 23.9921 42 21.332 42 18.5263C42' +
    ' 8.29451 33.9411 0 24 0C14.0589 0 6 8.29451 6 18.5263C6 21.332 6.60598 23.9921 7.69059 26.3754C11.0867' +
    ' 34.3491 18.852 40.762 24 44C29.148 40.762 36.9133 34.3491 40.3094 26.3754Z" fill="'+color+'"/>' +
    '<path fill-rule="evenodd" clip-rule="evenodd" d="M21.0001 0.256205C29.5132 1.72623 36 9.3466 36 18.5264C36' +
    ' 21.3321 35.394 23.9921 34.3094 26.3754C31.5259 32.9109 25.807 38.398 21 41.9476C16.193 38.398 10.4741' +
    ' 32.9109 7.69058 26.3754C6.60598 23.9921 5.99999 21.3321 5.99999 18.5264C5.99999 9.34658 12.4869 1.72617' +
    ' 21.0001 0.256205ZM19.6326 42.9236C14.7788 39.2673 9.08068 33.7085 6.22617 27.0203C5.05342 24.4367 4.39999' +
    ' 21.5573 4.39999 18.5264C4.39999 10.3246 9.19186 3.22973 16.0941 0.102661C7.04894 1.0824 0 8.95712 0' +
    ' 18.5264C0 21.3321 0.605981 23.9921 1.69059 26.3754C5.08668 34.3491 12.852 40.7621 18 44C18.5199 43.673' +
    ' 19.0665 43.3137 19.6326 42.9236Z" fill="'+color+'"/>' +
    '</svg>');

  return ('data:image/svg+xml;base64,' + encoded);
}

function updateHomeButton () {
  const center = new google.maps.LatLng(mapData.staticMarkers['0'].lat,mapData.staticMarkers['0'].lng);
  mapCenterChangeHandler(undefined, center);
}
//
function latLonToOffsets(latitude, longitude, mapWidth, mapHeight) {
  const FE = 180; // false easting
  const radius = mapWidth / (2 * Math.PI);

  const latRad = degreesToRadians(latitude);
  const lonRad = degreesToRadians(longitude + FE);

  const x = lonRad * radius;

  const yFromEquator = radius * Math.log(Math.tan(Math.PI / 4 + latRad / 2));
  const y = mapHeight / 2 - yFromEquator;

  return { x, y };
}

function degreesToRadians(degrees) {
  return (degrees * Math.PI) / 180;
}

function latLng2Point(latLng, map) {
  const topRight = map.getProjection().fromLatLngToPoint(map.getBounds().getNorthEast());
  const bottomLeft = map.getProjection().fromLatLngToPoint(map.getBounds().getSouthWest());
  const scale = Math.pow(2, map.getZoom());
  const worldPoint = map.getProjection().fromLatLngToPoint(latLng);

  return new google.maps.Point((worldPoint.x - bottomLeft.x) * scale, (worldPoint.y - topRight.y) * scale);
}

function mapCenterChangeHandler(btnGoHome = document.querySelector('.map__go-home__btn'), center){
  let top, left;
  let visible = false;
  let menuWidth = 0;
  let boundingBox;

  const mapContainer = getGoogleMapMainContainer();
  const homeIcon = document.querySelector('.home-btn__img');
  const btnWidth = btnGoHome.getBoundingClientRect().width;
  const btnHeight = btnGoHome.getBoundingClientRect().height;
  const width = mapContainer.getBoundingClientRect().width;
  const height = mapContainer.getBoundingClientRect().height;
  const menu = document.querySelector('.aside-menu__container.open-aside-menu');
  if (menu){
    menuWidth = menu.getBoundingClientRect().width;
  }
  const point = latLng2Point(center,map);

  if (dir === 'ltr' && !isDesktopMode()){
    boundingBox = {
      left: menuWidth,
      top: 0,
      right: width,
      bottom: height
    };
  } else if (dir === 'rtl' && !isDesktopMode()) {
    boundingBox = {
      left: 0,
      top: 0,
      right: width - menuWidth,
      bottom: height
    };
  } else if (isDesktopMode()){
    boundingBox = {
      left: 0,
      top: 0,
      right: width - menuWidth,
      bottom: height
    };
  }



  removeAllStyleProporty(btnGoHome);

  // Right
  if (point.x > boundingBox.right){
    left = boundingBox.right - btnWidth / 2;
    top = point.y - btnHeight / 2;
    homeIcon.src = rightIcon;
    visible = true;
  }

  // Bottom
  if (point.y > boundingBox.bottom){
    top = boundingBox.bottom - btnHeight;
    left = point.x;
    homeIcon.src = bottomIcon;
    visible = true;
  }

  // Left
  if (point.x < boundingBox.left){
    left = boundingBox.left + btnWidth / 2;
    top = point.y - btnHeight / 2;
    homeIcon.src = leftIcon;
    visible = true;
  }

  // Top
  if (point.y < boundingBox.top){
    top = boundingBox.top;
    left = point.x;
    homeIcon.src = topIcon;
    visible = true;
  }

  // Top - Right
  if (point.y < boundingBox.top && point.x > boundingBox.right){
    top = boundingBox.top;
    left = boundingBox.right - btnWidth / 2;
    homeIcon.src = topRightIcon;
    visible = true;
  }

  // Top - Left
  if (point.y < boundingBox.top && point.x < boundingBox.left){
    top = boundingBox.top;
    left = boundingBox.left + btnWidth / 2;
    homeIcon.src = topLeftIcon;
    visible = true;
  }

  //Bottom - Left
  if (point.y > boundingBox.bottom && point.x < boundingBox.left){
    top = boundingBox.bottom - btnHeight;
    left = boundingBox.left + btnWidth / 2;
    homeIcon.src = bottomLeftIcon;
    visible = true;
  }

  // Bottom - Right
  if (point.y > boundingBox.bottom && point.x > boundingBox.right){
    top = boundingBox.bottom - btnHeight;
    left = boundingBox.right - btnWidth / 2;
    homeIcon.src = bottomRightIcon;
    visible = true;
  }

  btnGoHome.style.left = left - btnWidth / 2 + 'px';
  btnGoHome.style.top = top + 'px';

  if (visible){
    btnGoHome.style.visibility = 'visible';
  }

}

function isPortraitMode () {
  return window.matchMedia("(orientation: portrait)").matches;
}

function removeAllStyleProporty(btnGoHome){
  btnGoHome.style.removeProperty('top');
  btnGoHome.style.removeProperty('bottom');
  btnGoHome.style.removeProperty('left');
  btnGoHome.style.removeProperty('right');
  btnGoHome.style.removeProperty('visibility');
}

function setCurrentHomeIcon (btnGoHome,homeIcon, correctionSideObject) {
  const top = parseFloat(btnGoHome.style.top);
  const left = parseFloat(btnGoHome.style.left);
  const right = parseFloat(btnGoHome.style.right);
  const bottom = parseFloat(btnGoHome.style.bottom);

  // TOP - LEFT / RIGHT
  if (top === correctionSideObject.top){
    homeIcon.src = topIcon;
  }

  if (right === correctionSideObject.right){
    homeIcon.src = rightIcon;
  }

  if (left === correctionSideObject.left){
    homeIcon.src = leftIcon;
  }

  if (top === correctionSideObject.top && left === correctionSideObject.left){
    homeIcon.src = topLeftIcon;
  }

  if (top === correctionSideObject.top && right === correctionSideObject.right){
    homeIcon.src = topRightIcon;
  }

  //BOTTOM / LEFT / RIGHT
  if (bottom === correctionSideObject.bottom){
    homeIcon.src = bottomIcon;
  }

  if (bottom === correctionSideObject.bottom && left === correctionSideObject.left){
    homeIcon.src = bottomLeftIcon;
  }

  if (bottom === correctionSideObject.bottom && right === correctionSideObject.right){
    homeIcon.src = bottomRightIcon;
  }

  btnGoHome.style.visibility = 'visible';
}

function setInitialZoom () {
  if (poiZoom === 0){

    let needZoomOut = false;
    const currentZoom = map.getZoom();

    Object.values(mapData.filteredMarkers).forEach(markersArray =>{
      markersArray.forEach(marker =>{
        const markerCoords = new google.maps.LatLng(marker.lat, marker.lng);
        const destPixel = getPixel(markerCoords, map.getZoom());
        const mapPixel = getPixel(map.getCenter(), map.getZoom());
        const diffX = (destPixel.x - mapPixel.x);
        const diffY = (destPixel.y - mapPixel.y);
        if (Math.abs(diffX) > window.innerWidth / 2  || Math.abs(diffY) > window.innerHeight / 2){
          needZoomOut = true;
        }
      });
    });

    if (needZoomOut){
      map.setZoom(currentZoom - 1);
      mapData.mapSettings.zoom = map.getZoom();
      setInitialZoom();
    }


  } else {
    map.setZoom(poiZoom);
    mapData.mapSettings.zoom = poiZoom;
  }

}

function isMobileDevice () {
  const match = window.matchMedia || window.msMatchMedia;
  if(match) {
    const mq = match("(pointer:coarse)");
    return mq.matches;
  }
  return false;
}

export function checkPoiResponse (poiData,poiCategories) {
  return Boolean(Array.isArray(poiData) && poiData.length && Array.isArray(poiCategories) && poiCategories.length);
}

function showErrorPage () {
  const mainContainer = document.querySelector('.'+canvasClass);
  const wrapper = createHtmlElement(mainContainer,'','div',['error-page__wrapper']);
  const icon = createHtmlElement(wrapper,'','div',['error-page__icon']);
  icon.innerHTML = desktopErrorIcon;
  const text = createHtmlElement(wrapper,'The page is under construction','h1',['error-page__title']);
}

export function smoothlyAnimatePanTo(map, destLatLng) {
  if(willAnimatePanTo(map, destLatLng)) {
    map.panTo(destLatLng);
    map.setZoom(mapData.mapSettings.zoom);
  } else {
    smoothlyAnimatePanToWorkarround(map, destLatLng);
  }
}

function smoothlyAnimatePanToWorkarround(map, destLatLng, optionalAnimationEndCallback) {
  let initialZoom = map.getZoom();
  let listener;

  function zoomIn() {
    map.setZoom(mapData.mapSettings.zoom);
    google.maps.event.removeListener(listener);
    //here you should (re?)enable only the ui controls that make sense to your app
    map.setOptions({draggable: true, zoomControl: true, scrollwheel: true, disableDoubleClickZoom: false});
  }

  function zoomOut() {
    if(willAnimatePanTo(map, destLatLng)) {
      google.maps.event.removeListener(listener);
      listener = google.maps.event.addListener(map, 'idle', zoomIn);
      map.panTo(destLatLng)
    } else {
      map.setZoom(getOptimalZoomOut(destLatLng, map.getZoom()));
    }
  }

  //here you should disable all the ui controls that your app uses
  map.setOptions({draggable: false, zoomControl: false, scrollwheel: false, disableDoubleClickZoom: true});
  map.setZoom(getOptimalZoomOut(destLatLng, initialZoom));
  listener = google.maps.event.addListener(map, 'idle', zoomOut);
}

function getOptimalZoomOut(latLng, currentZoom) {
  if(willAnimatePanTo(map, latLng, currentZoom - 1)) {
    return currentZoom - 1
  } else if(willAnimatePanTo(map, latLng, currentZoom - 2)) {
    return currentZoom - 2
  } else {
    return currentZoom - 3
  }
}

function willAnimatePanTo(map, destLatLng, optionalZoomLevel) {
  let dimen = getMapDimenInPixels(map);

  let mapCenter = map.getCenter();
  optionalZoomLevel = !!optionalZoomLevel ? optionalZoomLevel : map.getZoom();

  let destPixel = getPixel(destLatLng, optionalZoomLevel);
  let mapPixel = getPixel(mapCenter, optionalZoomLevel);
  let diffX = Math.abs(destPixel.x - mapPixel.x);
  let diffY = Math.abs(destPixel.y - mapPixel.y);

  return diffX < dimen.width && diffY < dimen.height
}

function project(latLng) {
  let TILE_SIZE = 256;

  let siny = Math.sin(latLng.lat() * Math.PI / 180);

  // Truncating to 0.9999 effectively limits latitude to 89.189. This is
  // about a third of a tile past the edge of the world tile.
  siny = Math.min(Math.max(siny, -0.9999), 0.9999);

  return new google.maps.Point(
    TILE_SIZE * (0.5 + latLng.lng() / 360),
    TILE_SIZE * (0.5 - Math.log((1 + siny) / (1 - siny)) / (4 * Math.PI)))
}

function getPixel(latLng, zoom) {
  let scale = 1 << zoom;
  let worldCoordinate = project(latLng);
  return new google.maps.Point(
    Math.floor(worldCoordinate.x * scale),
    Math.floor(worldCoordinate.y * scale))
}

function getMapDimenInPixels(map) {
  let zoom = map.getZoom();
  let bounds = map.getBounds();
  let southWestPixel = getPixel(bounds.getSouthWest(), zoom);
  let northEastPixel = getPixel(bounds.getNorthEast(), zoom);
  return {
    width: Math.abs(southWestPixel.x - northEastPixel.x),
    height: Math.abs(southWestPixel.y - northEastPixel.y)
  }
}

export class Swipe {
  constructor(element,enableMouseSwipe = false) {
    this.xDown = null;
    this.yDown = null;
    this.eventListeners = false;
    this.enableMouseSwipe = enableMouseSwipe;
    this.element = typeof(element) === 'string' ? document.querySelector(element) : element;
    this.direction = null;
    this.touchStartListener = null;
    this.mouseDownListener = null;
    this.touchMoveListener = null;
    this.mouseMoveListener = null;

    this.element.addEventListener('touchstart', this.touchStartListener = function(evt) {
      this.handleTouchStart(evt);
    }.bind(this), false);

    if(this.enableMouseSwipe){
      this.element.addEventListener('mousedown', this.mouseDownListener = function(evt) {
        this.handlerMouseDown(evt);
      }.bind(this), false);
    }

  }

  onLeft(callback) {
    if (!callback){
      return;
    }
    this.onLeft = callback;

    return this;
  }

  onRight(callback) {
    if (!callback){
      return;
    }
    this.onRight = callback;

    return this;
  }

  onUp(callback) {
    if (!callback){
      return;
    }
    this.onUp = callback;

    return this;
  }

  onDown(callback) {
    if (!callback){
      return;
    }
    this.onDown = callback;

    return this;
  }

  getDirection(){
    return this.direction;
  }

  handlerMouseDown(evt){
    this.xDown = evt.clientX;
    this.yDown = evt.clientY;
  }

  handleTouchStart(evt){
    this.xDown = evt.touches[0].clientX;
    this.yDown = evt.touches[0].clientY;
  }

  handleTouchMove(evt) {
    if ( ! this.xDown || ! this.yDown ) {
      return;
    }

    var xUp;
    var yUp;

    if (evt.touches){
      xUp = evt.touches[0].clientX;
      yUp = evt.touches[0].clientY;
    } else {
      xUp = evt.clientX;
      yUp = evt.clientY;
    }

    this.xDiff = this.xDown - xUp;
    this.yDiff = this.yDown - yUp;

    if ( Math.abs( this.xDiff ) > Math.abs( this.yDiff ) ) { // Most significant.
      if ( this.xDiff > 30 ) {
        this.direction = 'left';
        this.onLeft();
        this.xDown = null;
        this.yDown = null;
      } else if (this.xDiff < -30) {
        this.direction = 'right';
        this.onRight();
        this.xDown = null;
        this.yDown = null;
      }
    } else {
      if ( this.yDiff > 30 ) {
        this.direction = 'up';
        this.onUp();
        this.xDown = null;
        this.yDown = null;
      } else if(this.yDiff < -30) {
        this.direction = 'down';
        this.onDown();
        this.xDown = null;
        this.yDown = null;
      }
    }
  }

  run() {
    if (!this.eventListeners){

      if (this.enableMouseSwipe){
        this.element.addEventListener('mousemove', this.mouseMoveListener = function(evt) {
          this.handleTouchMove(evt);
        }.bind(this), false);
      }

      this.element.addEventListener('touchmove', this.touchMoveListener = function(evt) {
        this.handleTouchMove(evt);
      }.bind(this), false);
      this.eventListeners = true;
    }
  }

  stop() {
    this.xDown = null;
    this.yDown = null;
    this.direction = null;
    delete this.onLeft;
    delete this.onRight;
    delete this.onUp;
    delete this.onDown;
  }

  removeEventListeners() {
    if (this.eventListeners){
      this.element.removeEventListener('touchmove',this.touchMoveListener);
      this.element.removeEventListener('touchstart',this.touchStartListener);
      this.enableMouseSwipe && this.element.removeEventListener('mousemove',this.mouseMoveListener);
      this.enableMouseSwipe && this.element.removeEventListener('mousedown',this.mouseDownListener);
    }
  }
}


let basicStyleCss = `
.marker__label{
  filter: none;
}
`;

